import React from "react";
import axios from 'axios';
import "./App.css";
import ImeiConfig from './ImeiConfig';
import {
  Button,
  Card,
  Typography,
  Grid,
  Container,
  Checkbox,
  FormControlLabel,
  Switch,
  Dialog,
  TablePagination,
  TableHead,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  Menu,
  Tooltip,
  CircularProgress,
  DialogActions,
  TextField,
  Autocomplete,
  Modal,
  Box,
  Stack,
  MenuItem, Select, FormControl, InputLabel,
  IconButton,
  ClearIcon
} from "@mui/material";



import Form from 'react-bootstrap/Form';
import Table from "@mui/material/Table";
import PopupNotification from './PopupNotification';
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import debounce from "lodash.debounce";
import { useEffect, useState, useCallback, useRef } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNotification } from './context/NotificationContext';


const CustomProgressBar = ({ start, width, color, label, labelColor = 'black' }) => {
  if (width === 0) {
    return null;
  }

  return (
    <div
      style={{
        flexGrow: start === 0 ? 0 : 1,
        flexBasis: `${width}%`,
        backgroundColor: color,
        height: '20px',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'flex-basis 0.5s ease',
      }}
    >
      <span
        style={{
          fontSize: '1rem',
          color: labelColor,
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </span>
    </div>
  );
};








function Advanced() {
  const { showNotification } = useNotification();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [highlightAsr, setHighlightAsr] = useState(false);
  const [previousAsr, setPreviousAsr] = useState(null);
  const [highlight, setHighlight] = useState(false);
  const [failLight, setFailLight] = useState(false);
  const [notes, setNotes] = useState("");
  const [searchResultsList, setSearchResultsList] = useState([]);
  const [optionsOpen, setOptionsOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("skyline0929");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [open, setOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [offline, setOffline] = useState([]);
  const [lock, setLock] = useState([]);
  const [lockS, setLockS] = useState([]);
  const [lockF, setLockF] = useState([]);
  const [run, setRun] = useState([]);
  const [online, setOnline] = useState([]);
  const [noSig, setNoSig] = useState([]);
  const [lowSig, setLowSig] = useState([]);
  const [low2Sig, setLow2Sig] = useState([]);
  const [medSig, setMedSig] = useState([]);
  const [med2Sig, setMed2Sig] = useState([]);
  const [highSig, setHighSig] = useState([]);
  const [high2Sig, setHigh2Sig] = useState([]);
  const [fullSig, setFullSig] = useState([]);
  const [inserted, setInserted] = useState([]);
  const [fresh, setFresh] = useState([]);
  const [failed1, setFailed1] = useState([]);
  const [failed2, setFailed2] = useState([]);
  const [cooldownPorts, setCooldownPorts] = useState(new Set());
  const [openSim, setOpenSim] = useState(false);
  const [data, setData] = useState([]);

  const handleOpenSim = () => {
    axios.get(`https://frek.cc/proxy/${ip}:8851/setting/getNumberConfig`, {
      headers: {
        "Content-Type": "application/json",
        'x-access-token': accessToken
      }
    })
      .then(response => {
        const result = response.data;  // <-- Corrected this line
        if (result.code === 0) {
          setData(result.data.numberConfigList);
          setOpenSim(true);
        } else {
          console.error("Error fetching data:", result.msg);
        }
      })
      .catch(error => console.error("Fetch error:", error));
  };


  const handleCloseSim = () => {
    setOpenSim(false);
  };

  const handleChange = (index, field, value) => {
    const newData = [...data];
    newData[index][field] = value;
    setData(newData);
  };

  const handleSave = () => {
    axios.post(`https://frek.cc/proxy/${ip}:8851/setting/saveNumberConfig`, {
      enable: 1,
      numberConfigList: data
    }, {
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': accessToken
      }
    })
      .then(response => {
        const result = response.data;
        console.log(result);
        handleNotification(` PC${getPcNumberFromIp(ip)} Sim Settings Updated`);
      })
      .catch(error => console.error("Error:", error));
  };


  const handleGetNumber = () => {
    axios.get(`https://frek.cc/proxy/${ip}:8851/setting/getNumber`, {
      headers: {
        "Content-Type": "application/json",
        'x-access-token': accessToken
      }
    })
      .then(response => {
        const result = response.data;
        if (result.code === 0) {
          console.log("Success:", result.msg);
          // You can set state or handle the result data here if needed
        } else {
          console.error("Error fetching data:", result.msg);
        }
        handleCloseSim();
        handleNotification(` PC${getPcNumberFromIp(ip)} Fetching Numbers Successful`);
      })
      .catch(error => console.error("Fetch error:", error));
  };



  const tableTopRef = useRef(null);
  const inboxTableTopRef = useRef(null);

  const [lockingSettingsModalOpen, setLockingSettingsModalOpen] = useState(false);
  const [lockingSettings, setLockingSettings] = useState({
    enable: 0,
    sendEnable: 0,
    sendCnt: 0,
    sendTime: 0,
    failEnable: 0,
    failCnt: 0,
    failTime: 0,
    contEnable: 0,
    contCnt: 0,
    contTime: 0,
    sentSize: 0,
  });

  const [showInbox, setShowInbox] = useState(false);

  const hardcodedPassword = "SHOW"; //TESTING CHANGES
  const timeoutRef = useRef(); // A ref to keep track of the timeout

  const usernames = [
    "RHM0929567SM515",
    "RHM0929567SMa515",
    "RHM0929567SMb515",
    "RHM0929567SMc515",
    "RHM0929567SMd515",
    "RHM0929567SMe515",
    "RHM0929567SMf515",
    "RHM0929567SMg515",
    "RHM0929567SMh515",
    "RHM0929567SMi515",
    "RHM0929567SMj515",
    "RHM0929567SMk515",
    "RHM0929567SMl515",
    "RHM0929567SMm515",
    "RHM0929567SMn515",
    "RHM0929667SM515",
    "RHM0929667SMa515",
    "RHM0929667SMb515",
    "RHM0929667SMc515",
    "RHM0929667SMd515",
    "RHM0929667SMe515",
    "RHM0929667SMf515",
    "RHM0929667SMg515",
    "RHM0929667SMh515",
    "RHM0929667SMi515",
    "RHM0929667SMj515",
    "RHM0929667SMk515",
    "RHM0929667SM1515",
    "RHM0929667SMm515",
    "RHM0929667SMn515"
  ];


  const commandSuggestions = [
    "AT+QLEDMODE=0",
    "AT+QLEDMODE=5",
    "ATD09519969666;",
    "ATD09103111666;",
    "ATH",
    "AT+CFUN=1,1"
    // ... other commands
  ];


  const generateRandomPhoneNumber = (prefix) => {
    let number = prefix;
    while (number.length < 11) {
      number += Math.floor(Math.random() * 10); // adds a random digit
    }
    return number;
  };



  const phoneNumberSuggestions = [
    "214",
    "Random Globe Number", // Random number starting with 0962
    "Random Smart Number", // Random number starting with 0965
    "808",
    // ... other numbers

  ];



  const handleIndividualSMSChange = (port, event, newValue) => {
    let newSMSValue = newValue;
    if (newValue === "Random SMS") {
      newSMSValue = generateRandomString(); // Assuming you have this function defined
    }

    setIndividualModalData(prevData => ({
      ...prevData,
      [port]: { ...prevData[port], sms: newSMSValue }
    }));
  };




  const generateRandomString = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789';
    let result = '';
    for (let i = 0; i < 5; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  };



  const handleIndividualPhoneNumberChange = (port, event, newValue) => {
    let newAddressValue = newValue;

    if (newValue === "Random Globe Number") {
      newAddressValue = generateRandomPhoneNumber("0967");
    } else if (newValue === "Random Smart Number") {
      newAddressValue = generateRandomPhoneNumber("0951");
    }

    setIndividualModalData(prevData => ({
      ...prevData,
      [port]: { ...prevData[port], address: newAddressValue }
    }));
  };



  const handleInputChange = (event, newInputValue) => {
    const name = "sms";
    if (newInputValue === "Random SMS") {
      setCommonModalData(prevData => ({ ...prevData, [name]: generateRandomString() }));
    } else {
      setCommonModalData(prevData => ({ ...prevData, [name]: newInputValue }));
    }
  };



  const handlePhoneNumberChange = (event, newInputValue) => {
    const name = "address";
    if (newInputValue === "Random Globe Number") {
      setCommonModalData(prevData => ({ ...prevData, [name]: generateRandomPhoneNumber("0967") }));
    } else if (newInputValue === "Random Smart Number") {
      setCommonModalData(prevData => ({ ...prevData, [name]: generateRandomPhoneNumber("0951") }));
    } else {
      setCommonModalData(prevData => ({ ...prevData, [name]: newInputValue }));
    }
  };


  // Define messageSuggestions array at the top of your component file
  const messageSuggestions = [
    "?1515",
    "You have submitted",

    // ... other common messages

  ];

  // ... rest of your component code


  const [suggestions, setSuggestions] = useState([
    "?1515",
    "You have submitted",

    // ... other common messages
  ]);

  // Update suggestions to include a random string
  useEffect(() => {
    setSuggestions(prevSuggestions => [
      ...prevSuggestions.slice(0, 3), // Keep the first 3 fixed suggestions
      generateRandomString(),         // Add a random string
      // ... Add other dynamic or common messages if needed
    ]);
  }, []); // Empty dependency array ensures this runs once on mount



  const ussdCommandSuggestions = [
    "*123#",
    "*123*9*2#",
    "*123*6*2#",
    "*5623#",
    "3",
    "1",
    "2",
    "9",
    "6",
    "10"
    // ... other commands
  ];







  const authenticateUser = () => {
    // Use the prompt function to ask the user for their password
    let enteredPassword = window.prompt("Please enter 'SHOW' to proceed:");
    // Check if the entered password matches the hardcoded password
    return enteredPassword === hardcodedPassword;
  };

  const handleToggleInbox = () => {
    if (showInbox) {
      setShowInbox(false);
      localStorage.setItem("showInbox", "0");
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    } else {
      if (authenticateUser()) {
        setShowInbox(true);
        localStorage.setItem("showInbox", "1");
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
          setShowInbox(false);
          localStorage.setItem("showInbox", "0");
        }, 300000); // It will toggle off after 30 Minutes
      } else {
        alert("Invalid password. Please try again.");
      }
    }
  };





  // Initialize showInbox from localStorage when the component mounts
  useEffect(() => {
    const savedState = localStorage.getItem("showInbox");
    if (savedState) {
      setShowInbox(savedState === "1");
    }
  }, []);


  const [showPort, setShowPort] = useState(false);

  useEffect(() => {
    const savedState = localStorage.getItem("showPort");
    if (savedState) {
      setShowPort(savedState === "1");
    }
  }, []);

  const handleTogglePort = () => {
    if (showPort) {
      setShowPort(false);
      localStorage.setItem("showPort", "0");
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    } else {
      if (authenticateUser()) {
        setShowPort(true);
        localStorage.setItem("showPort", "1");
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
          setShowPort(false);
          localStorage.setItem("showPort", "0");
        }, 300000); // It will toggle off after 30 Minutes
      } else {
        alert("Invalid password. Please try again.");
      }
    }
  };









  const [disablePortsConfirmOpen, setDisablePortsConfirmOpen] = React.useState(false);
  // Add the state variables for SMS control
  const [smsControlEnable, setSmsControlEnable] = useState(0);
  const [type, setType] = useState(0);
  const [maxCnt, setMaxCnt] = useState(null);
  const [dayMaxCnt, setDayMaxCnt] = useState(0);
  const [sendding, setSendding] = useState(0);
  const [seconds, setSeconds] = useState(null);
  const [randomSeconds, setRandomSeconds] = useState(0);
  const [secondsMin, setSecondsMin] = useState(null);
  const [secondsMax, setSecondsMax] = useState(null);
  const [sentSize, setSentSize] = useState(null);

  // Add the state variable for the SMS control modal
  const [smsControlModalOpen, setSmsControlModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  // Add the state for the enable confirmation modal
  const [enablePortsConfirmOpen, setEnablePortsConfirmOpen] = React.useState(false);
  const [enable, setEnable] = useState(0);
  const [contCnt, setContCnt] = useState("");
  const [contTime, setContTime] = useState("");
  const [inboxData, setInboxData] = useState([]);
  const [editSlotModalOpen, setEditSlotModalOpen] = useState(false);
  const [editSlotModalData, setEditSlotModalData] = useState({});
  const [slotIdErrors, setSlotIdErrors] = useState({});
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [getNumbersData, setGetNumbersData] = useState({ numbers: "" });
  const [getNumbersModalOpen, setGetNumbersModalOpen] = useState(false);
  const [nosig, setNosig] = useState([]);
  const [good, setGood] = useState([]);
  const [off, setOff] = useState([]);
  const [processed, setProcessed] = useState([]);
  const [individualModalData, setIndividualModalData] = useState({});
  const [commonModalData, setCommonModalData] = useState({ address: "", sms: "" });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(32);
  const [selectAll, setSelectAll] = useState(false);
  const [ports, setPorts] = useState([]);
  const [sending, setSending] = useState([]);
  const [failed, setFailed] = useState([]);
  const [selectedPorts, setSelectedPorts] = useState(new Set());
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState({ address: "", sms: "" });
  const [numbers,] = useState({});
  const [ussdResults, setUSSDResults] = useState({});
  const [atResults, setATResults] = useState({});
  const [contentModalOpen, setContentModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [ussdResultsList, setUSSDResultsList] = useState(
    Array.from(selectedPorts).map((port) => ({
      port,
      command: '',
      result: '',
      autocompleteCommand: '', // Add this to store the autocomplete input
    }))
  );

  // Define the controller outside of your fetch function
  let fetchController = new AbortController();

  // Function to abort the fetch
  function abortFetch() {
    fetchController.abort();
    // Create a new controller for the next fetch
    fetchController = new AbortController();
  }
  const fetchIntervalRef = useRef(null);
  const isModalOpenRef = useRef(false);


  // Define the controller outside of your getData function
  let dataFetchController = new AbortController();

  // Function to abort the getData fetch
  function abortDataFetch() {
    dataFetchController.abort();
    // Create a new controller for the next fetch
    dataFetchController = new AbortController();
  }


  // Define the controller outside of your getPorts function
  let portsFetchController = new AbortController();

  // Function to abort the getPorts fetch
  function abortPortsFetch() {
    portsFetchController.abort();
    // Create a new controller for the next fetch
    portsFetchController = new AbortController();
  }

  const [atResultsList, setATResultsList] = useState(
    Array.from(selectedPorts).map((port) => ({ port, data: null }))
  );
  const [cardData, setCardData] = useState({
    asr: "0",
    todaySent: "0",
    todayFailed: "0",
  });
  useEffect(() => {
    debouncedChangeHandler();
  });

  const accessToken = "uBEiuHBXrDfiuthssKUQFN4xyJzmWPj3"


  const [defaultIp, setDefaultIp] = useState('10.147.19.123');
  const [ip, setIp] = useState(localStorage.getItem('ip') || defaultIp);
  const [isLoading, setIsLoading] = useState(true);
  const [availablePcs, setAvailablePcs] = useState([]);

  useEffect(() => {
    fetch("https://frek.cc/proxy/38.54.86.24:5000/expiry/1000")
      .then((response) => response.json())
      .then((data) => {
        if (data[0] && data[0].value) {
          const pcValues = data[0].value.split(",").map(Number);
          setAvailablePcs(pcValues);

          if (!localStorage.getItem('ip')) {
            const defaultIpNumber = pcValues[0] + 100;
            const newDefaultIp = `10.147.19.${defaultIpNumber}`;
            setDefaultIp(newDefaultIp);
            setIp(newDefaultIp);
            localStorage.setItem('ip', newDefaultIp);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching PC numbers:", error);
        setIsLoading(false);
      });
  }, []);




  const handleChangeIp = (event) => {
    setIp(event.target.value);
    localStorage.setItem('ip', event.target.value);
    window.location.reload();
  }

  function getPcNumberFromIp(ip) {
    let parts = ip.split('.');
    let lastPart = Number(parts[parts.length - 1]);
    return lastPart - 100;
  }


  const generateIpOptions = () => {
    const ipOptions = [];

    for (let i = 100; i <= 123; i++) {
      const ipAddress = `10.147.19.${i}`;
      const pcNumber = i - 100;
      const pcName = `PC${pcNumber.toString().padStart(2, '0')}`; // Pad with zero for consistency

      // Check if PC number is in the available list, or is PC00 or PC23
      const isDisabled = pcNumber !== 0 && pcNumber !== 23 && !availablePcs.includes(pcNumber);

      ipOptions.push(
        <MenuItem value={ipAddress} key={ipAddress} disabled={isDisabled}>
          {pcName}
        </MenuItem>
      );
    }

    return ipOptions;
  };







  const handleCheckBalance = () => {
    setOpenConfirm(true);
  };

  const handleConfirm = async () => {
    setOpenConfirm(false);
    // Make the request to the server
    try {
      const response = await fetch(`https://frek.cc/proxy/${ip}:8851/auto/getBalance`, {
        method: 'GET', headers: {
          'x-access-token': accessToken
        }
      },);
      const result = await response.json();
      console.log(result);
    } catch (error) {
      console.error('Error fetching balance:', error);
    }
    handleNotification(` PC${getPcNumberFromIp(ip)} Checking Balance Started`);
  };

  const handleCancel = () => {
    setOpenConfirm(false);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLockingSettingsClick = () => {
    setLockingSettingsModalOpen(true);
  };


  const handleSearchModalClose = () => {
    setSearchModalOpen(false);
  };

  const handleSearchButtonClick = () => {
    // Add your search logic here
    // Filter the ussdResultsList based on the searchKeyword and update the searchResultsList
    const filteredResults = ussdResultsList.filter(resultItem =>
      resultItem.result.toLowerCase().includes(searchKeyword.toLowerCase())
    );

    setSearchResultsList(filteredResults);
    setSearchModalOpen(true);
  };

  const handleSearchKeywordChange = (event) => {
    setSearchKeyword(event.target.value);
  };



  // Function to open the confirmation modal
  const openDisablePortsConfirm = () => {
    handleClose();
    setDisablePortsConfirmOpen(true);
  };

  // Function to open the enable confirmation modal
  const openEnablePortsConfirm = () => {
    handleClose();
    setEnablePortsConfirmOpen(true);
  };

  // Function to close the enable confirmation modal
  const closeEnablePortsConfirm = () => {
    setEnablePortsConfirmOpen(false);
  };

  const handleEnablePorts = async () => {
    closeEnablePortsConfirm();
    for (const port of selectedPorts) {
      await handleProcess(port);
      handleNotification(` PC${getPcNumberFromIp(ip)} Ports Enabling Success!`);
    }
  };

  // Function to close the confirmation modal
  const closeDisablePortsConfirm = () => {
    setDisablePortsConfirmOpen(false);
  };

  const handleCloseLockingSettingsModal = () => {
    setLockingSettingsModalOpen(false);
  };

  const scrollToInboxTop = () => {
    if (inboxTableTopRef.current) {
      inboxTableTopRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };


  const [inboxPage, setInboxPage] = React.useState(0);
  const [inboxRowsPerPage, setInboxRowsPerPage] = React.useState(10);


  // Add functions to handle SMS control modal open and close
  const handleSMSControlModalOpen = () => {
    setSmsControlModalOpen(true);
  };

  const handleSMSControlModalClose = () => {
    setSmsControlModalOpen(false);
  };

  const handleRandomSecondsChange = (event) => {
    setRandomSeconds(event.target.checked ? 1 : 0);
  };

  const handleSenddingChange = (event) => {
    setSendding(event.target.checked ? 1 : 0);
  };

  const handleSmsControlEnableChange = (event) => {
    setSmsControlEnable(event.target.checked ? 1 : 0);
  };

  const handleTypeChange = (event) => {
    setType(parseInt(event.target.value));
  };

  const handleMaxCntChange = (event) => {
    setMaxCnt(parseInt(event.target.value));
  };

  const handleDayMaxCntChange = (event) => {
    setDayMaxCnt(parseInt(event.target.value));
  };

  const handleSecondsChange = (event) => {
    setSeconds(parseInt(event.target.value));
  };

  const handleSentSizeChange = (event) => {
    setSentSize(parseInt(event.target.value));
  };

  const handleSecondsMinChange = (event) => {
    setSecondsMin(parseInt(event.target.value));
  };

  const handleSecondsMaxChange = (event) => {
    setSecondsMax(parseInt(event.target.value));
  };


  const handleInboxChangePage = (event, newPage) => {
    setInboxPage(newPage);
  };

  const handleInboxChangeRowsPerPage = (event) => {
    setInboxRowsPerPage(parseInt(event.target.value, 10));
    setInboxPage(0);
    setTimeout(() => {
      scrollToInboxTop();
    }, 100);
  };


  const openLockingSettingsModal = () => {
    fetchLockingSettings();
    setLockingSettingsModalOpen(true);
  };

  const sortByDateString = (a, b) => {
    return b.dateStr.localeCompare(a.dateStr);
  };

  const closeLockingSettingsModal = () => {
    setLockingSettingsModalOpen(false);
  };

  const handleLockingSettingsChange = (event, fieldName) => {
    const value = event.target.type === 'checkbox' ? (event.target.checked ? 1 : 0) : event.target.value;
    setLockingSettings((prevState) => ({ ...prevState, [fieldName]: value }));
  };


  const openContentModal = (row) => {
    setModalContent(row);
    setContentModalOpen(true);
  };

  const closeContentModal = () => {
    setContentModalOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };


  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  // Sorting logic
  const sortedPorts = [...ports].sort((a, b) => {
    if (sortColumn === null) return 0;

    let aValue;
    let bValue;

    switch (sortColumn) {
      case "slot":
        aValue = a.slotId;
        bValue = b.slotId;
        break;
      case "port":
        aValue = parseInt(a.portName.replace(/[^0-9]/g, ""));
        bValue = parseInt(b.portName.replace(/[^0-9]/g, ""));
        break;
      case "number":
        aValue = a.sim;
        bValue = b.sim;
        break;
      case "status":
        aValue = a.status === 3 || a.status === 4 ? 0 : a.network;
        bValue = b.status === 3 || b.status === 4 ? 0 : b.network;
        break;
      case "signal":
        aValue = a.signal;
        bValue = b.signal;
        break;
      case "sent":
        aValue = a.chargeCnt;
        bValue = b.chargeCnt;
        break;
      case "failed":
        aValue = a.fail;
        bValue = b.fail;
        break;
      case "rate":
        aValue = a.successRate;
        bValue = b.successRate;
        break;
      case "fail streak":
        aValue = a.successionFail;
        bValue = b.successionFail;
        break;
      case "balance":
        aValue = a.balance;
        bValue = b.balance;
        break;
      default:
        return 0;
    }

    if (sortDirection === "asc") {
      return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
    } else {
      return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
    }
  });


  const handleSelectAll = (event) => {
    const newSelectAll = event.target.checked;
    setSelectAll(newSelectAll);

    if (newSelectAll) {
      const newSelectedPorts = new Set(
        sortedPorts
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((port) => port.portName.replace(/[^0-9]/g, ""))
      );
      setSelectedPorts(newSelectedPorts);
      return;
    }
    setSelectedPorts(new Set());
  };





  const handleGetNumbersModalOpen = () => {
    setGetNumbersModalOpen(true);
  };

  const handleGetNumbersModalClose = () => {
    setGetNumbersModalOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setTimeout(() => {
      scrollToTop();
    }, 100);
  };


  const handleUSSDModalSubmit = async () => {
    // Set the initial state of the results as "Waiting for result..."
    setUSSDResultsList(
      Array.from(selectedPorts).map((port) => ({ port, result: '' }))
    );

    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

    for (const [index, port] of Array.from(selectedPorts).entries()) {
      if (index > 0) {
        // Wait for 1 second before sending the next request
        await delay(50);
      }

      // Send USSD request without waiting for the result
      handleUSSD(port, ussdModalData.command).then(({ success, result }) => {
        if (success) {
          // Update the state with the successful result
          setUSSDResultsList((prevResultsList) =>
            prevResultsList.map((item) =>
              item.port === port ? { ...item, result } : item
            )
          );
        } else {
          // Update the state with the error message
          setUSSDResultsList((prevResultsList) =>
            prevResultsList.map((item) =>
              item.port === port ? { ...item, result: `Error: ${result}` } : item
            )
          );
        }
      });
    }
  };




  const handleCommandChange = (event, port) => {
    const newCommand = event.target.value;
    setUSSDResultsList((prevResultsList) =>
      prevResultsList.map((item) =>
        item.port === port ? { ...item, command: newCommand, autocompleteCommand: newCommand } : item
      )
    );
  };



  const handleIndividualSend = async (port) => {
    // Set the result to an empty string for the port, triggering the CircularProgress display
    setUSSDResultsList((prevResultsList) =>
      prevResultsList.map((item) =>
        item.port === port ? { ...item, result: '' } : item
      )
    );

    // Find the command for the port
    const item = ussdResultsList.find((item) => item.port === port);

    // Handle case where item is not found
    if (!item) {
      console.error(`No item found for port ${port}`);
      // Set a default error message or return
      setUSSDResultsList((prevResultsList) =>
        prevResultsList.map((item) =>
          item.port === port ? { ...item, result: 'Command not found' } : item
        )
      );
      return;
    }

    const command = item.autocompleteCommand;

    // Perform the USSD send operation
    const { success, result = '' } = await handleUSSD(port, command);
    const finalResult = result ?? 'Default Result';

    // Update the result for the specific port
    if (success) {
      setUSSDResultsList((prevResultsList) =>
        prevResultsList.map((item) =>
          item.port === port ? { ...item, result: finalResult } : item
        )
      );
    } else {
      setUSSDResultsList((prevResultsList) =>
        prevResultsList.map((item) =>
          item.port === port ? { ...item, result: `Error: ${finalResult}` } : item
        )
      );

      // Add port to cooldown and remove it after 5 seconds
      setCooldownPorts((prev) => new Set(prev).add(port));
      setTimeout(() => {
        setCooldownPorts((prev) => {
          const newSet = new Set(prev);
          newSet.delete(port);  // Corrected this line
          console.log("Cooldown ports updated:", newSet);
          return newSet;
        });
      }, 5000);
    }
  };





  const [ussdCommand, setUssdCommand] = useState("");

  const [ussdModalOpen, setUSSDModalOpen] = useState(false);
  const [ussdModalData, setUSSDModalData] = useState({ command: "", result: "" });

  const handleUSSDModalOpen = () => {
    isModalOpenRef.current = true;
    abortFetch(); // Abort any ongoing fetches for inbox data
    abortDataFetch(); // Abort any ongoing fetches for home data
    abortPortsFetch(); // Abort any ongoing fetches for port data
    setUSSDModalOpen(true);
  };

  const handleUSSDModalClose = () => {
    isModalOpenRef.current = false;
    setUSSDModalOpen(false);
    // Optionally re-trigger the fetches here if you want them to run immediately after closing the modal
    fetchInboxData();
    getData();
    getPorts();
  };





  const handleUssdCommandChange = (event) => {
    setUssdCommand(event.target.value);
  };

  const handleUSSDModalDataChange = (event) => {
    const { name, value } = event.target;
    setUSSDModalData((prevData) => ({ ...prevData, [name]: value }));
  };






  const handleATModalSubmit = async () => {
    // Set the initial state of the results as "Waiting for result..."
    setATResultsList(
      Array.from(selectedPorts).map((port) => ({ port, result: null }))
    );

    for (const port of selectedPorts) {
      handleAT(port, atModalData.command).then(
        (result) => {
          setATResultsList((prevResultsList) =>
            prevResultsList.map((item) =>
              item.port === port ? { ...item, result } : item
            )
          );
        }
      );
    }
  };

  const [atCommand, setAtCommand] = useState("");

  const [atModalOpen, setATModalOpen] = useState(false);
  const [atModalData, setATModalData] = useState({ command: "", result: "" });

  const handleATModalOpen = () => {
    isModalOpenRef.current = true;
    abortFetch(); // Abort any ongoing fetches for inbox data
    abortDataFetch(); // Abort any ongoing fetches for home data
    abortPortsFetch(); // Abort any ongoing fetches for port data
    setATModalOpen(true);
  };

  const handleATModalClose = () => {
    isModalOpenRef.current = false;
    setATModalOpen(false);
    // Optionally re-trigger the fetches here if you want them to run immediately after closing the modal
    fetchInboxData();
    getData();
    getPorts();
  };

  const handleAtCommandChange = (event) => {
    setAtCommand(event.target.value);
  };

  const handleATModalDataChange = (event) => {
    const { name, value } = event.target;
    setATModalData((prevData) => ({ ...prevData, [name]: value }));
  };







  useEffect(() => {
    if (ip) {
      // Extract the last part of the IP address and subtract 100 to get the PC number
      const pcNumber = parseInt(ip.split('.').pop()) - 100;
      document.title = `PC${pcNumber} - Advanced Settings`;
    } else {
      document.title = 'Advanced Settings';
    }
  }, [ip]);


  useEffect(() => {
    setSending(
      ports
        .filter((a) => a.status === 1)
        .sort((a, b) => {
          if (a.slotId > b.slotId) return 1;
          if (a.slotId < b.slotId) return -1;
          return 0;
        })
    );
  }, [ports]);
  const debouncedChangeHandler = useCallback(debounce(getPorts, 500), []);

  const handlePortSelection = (port) => {
    const newSelectedPorts = new Set(selectedPorts);
    if (selectedPorts.has(port)) {
      newSelectedPorts.delete(port);
    } else {
      newSelectedPorts.add(port);
    }
    setSelectedPorts(newSelectedPorts);
  };

  const handleModalOpen = () => {
    isModalOpenRef.current = true;
    abortFetch(); // Abort any ongoing fetches for inbox data
    abortDataFetch(); // Abort any ongoing fetches for home data
    abortPortsFetch(); // Abort any ongoing fetches for port data
    setModalOpen(true);
  };

  const handleModalClose = () => {
    isModalOpenRef.current = false;
    setModalOpen(false);
    // Optionally re-trigger the fetches here if you want them to run immediately after closing the modal
    fetchInboxData();
    getData();
    getPorts();
  };

  const handleModalSubmit = async () => {
    for (const port of selectedPorts) {
      const data = individualModalData[port] || commonModalData;
      await handleActivate(port, data.address, data.sms);
      handleNotification(` PC${getPcNumberFromIp(ip)} Sending SMS Success!`);
    }
    handleModalClose();
  };

  const handleModalDataChange = (event) => {
    const { name, value } = event.target;
    setModalData((prevData) => ({ ...prevData, [name]: value }));
  };


  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const fileContent = e.target.result;
      const lines = fileContent.split(/\r?\n/);
      updateSlotIds(lines);
    };
    reader.readAsText(file);
  };

  const updateSlotIds = (lines) => {
    const newEditSlotModalData = { ...editSlotModalData };
    const simNoPrefixes = ['63', '0']; // Adjust this based on the SIM number prefixes

    for (const port in newEditSlotModalData) {
      const simNo = newEditSlotModalData[port].simNo;
      const formattedLines = lines.map((line) => {
        const existingPrefix = simNoPrefixes.find((prefix) => line.startsWith(prefix));

        if (!existingPrefix) {
          return simNoPrefixes[0] + line.trim(); // Default to the first prefix if no valid prefix is found
        }
        return line.trim();
      });

      const lineIndex = formattedLines.findIndex((formattedLine) => formattedLine === simNo);

      if (lineIndex !== -1) {
        newEditSlotModalData[port].slotId = lineIndex + 1;
      }
    }

    setEditSlotModalData(newEditSlotModalData);
  };

  const handleEditSlotModalOpen = () => {
    // Set the flag to indicate that a modal is open
    isModalOpenRef.current = true;

    // Abort all ongoing fetch operations
    abortFetch();          // For fetchInboxData
    abortDataFetch();      // For getData
    abortPortsFetch();     // For getPorts
    // ... any other abort functions for other fetch operations

    // Set up initial data for the edit slot modal
    const initialData = Array.from(selectedPorts).reduce((acc, port) => {
      const portData = ports.find((p) => p.portName.replace(/[^0-9]/g, "") === port);
      acc[port] = {
        simNo: portData.sim,
        slotId: portData.slotId,
      };
      return acc;
    }, {});

    setEditSlotModalData(initialData);
    setEditSlotModalOpen(true);
  };

  const handleEditSlotModalClose = () => {
    // Reset the flag as the modal is now closed
    isModalOpenRef.current = false;

    // Re-establish any fetch intervals or restart fetch operations as needed
    fetchInboxData();
    getData();
    getPorts();
    // ... any other fetch operations that need to be restarted

    setEditSlotModalOpen(false);
  };


  // New function to handle submitting the edit slot modal
  const handleEditSlotModalSubmit = async () => {
    for (const port in editSlotModalData) {
      const data = editSlotModalData[port];
      await handleSlot(port, data.simNo, data.slotId);
    }
    handleEditSlotModalClose();
    handleNotification(` PC${getPcNumberFromIp(ip)} Edit Slot successful`);
  };

  // New function to handle changes in the edit slot modal
  const handleEditSlotModalDataChange = (port, field, value) => {
    if (field === "slotId" && !/^\d*$/.test(value)) {
      setSlotIdErrors((prevErrors) => ({
        ...prevErrors,
        [port]: true,
      }));
    } else {
      setSlotIdErrors((prevErrors) => ({
        ...prevErrors,
        [port]: false,
      }));

      setEditSlotModalData((prevData) => ({
        ...prevData,
        [port]: {
          ...prevData[port],
          [field]: value,
        },
      }));
    }
  };

  const sortByDate = (a, b) => {
    const dateA = new Date(a.dateStr);
    const dateB = new Date(b.dateStr);

    if (dateA < dateB) {
      return 1;
    } else if (dateA > dateB) {
      return -1;
    } else {
      return a.from.localeCompare(b.from);
    }
  };


  // Add the form handler from the previous example
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      enable: smsControlEnable,
      type,
      maxCnt,
      dayMaxCnt,
      sendding,
      seconds,
      randomSeconds,
      secondsMin,
      secondsMax,
      sentSize,
    };

    try {
      const response = await axios.post(
        `https://frek.cc/proxy/${ip}:8851/setting/saveCeiling`,
        payload
        ,
        {
          headers: {
            'x-access-token': accessToken
          }
        }
      );
      if (response.data.code === 0) {
        handleNotification(` PC${getPcNumberFromIp(ip)} SMS Control Setting Updated`);
      } else {
        alert("An error occurred while saving settings");
      }
    } catch (error) {
      console.error(error);
      alert("An error occurred while saving settings");
    }

  };

  const handleDisablePorts = async () => {
    closeDisablePortsConfirm();
    for (const port of selectedPorts) {
      await handleDisablePort(port);
      handleNotification(` PC${getPcNumberFromIp(ip)} Port Disabling Success!`);
    }
  };


  const fetchLockingSettings = async () => {
    try {
      const response = await axios.get(`https://frek.cc/proxy/${ip}:8851/setting/getLock`, { headers: { 'x-access-token': accessToken } });
      const data = response.data.data;

      setLockingSettings({
        ...lockingSettings,
        enable: data.enable,
        sendEnable: data.sendEnable,
        sendCnt: data.sendCnt,
        sendTime: data.sendTime,
        failEnable: data.failEnable,
        failCnt: data.failCnt,
        failTime: data.failTime,
        contEnable: data.contEnable,
        contCnt: data.contCnt,
        contTime: data.contTime,
      });
    } catch (error) {
      console.error("Error fetching locking settings:", error);
    }
  };



  const fetchInboxData = async () => {
    // Check if the modal is open before fetching
    if (isModalOpenRef.current) {
      console.log('Modal is open, skipping fetch');
      return;
    }

    try {
      const response = await fetch(`https://frek.cc/proxy/${ip}:8851/inbox/query`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'x-access-token': accessToken
        },
        body: JSON.stringify({
          pageSize: 1,
          size: 5000,
          ascs: [],
          descs: [],
        }),
        signal: fetchController.signal, // Pass the controller's signal to the fetch call
      });

      // If the fetch was aborted, the code below this will not execute
      const data = await response.json();
      setInboxData(data.data.data);
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Fetch was aborted');
      } else {
        console.error('Fetch error:', error);
      }
    }
  };

  useEffect(() => {
    fetchInboxData();

    // Set up an interval to call fetchInboxData every 2 seconds
    fetchIntervalRef.current = setInterval(fetchInboxData, 2000);

    // Return a cleanup function to clear the interval when the component is unmounted
    return () => {
      if (fetchIntervalRef.current) {
        clearInterval(fetchIntervalRef.current);
      }
    };
  }, []); // Empty array means this effect runs once when the component mounts




  const fetchSettingsData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`https://frek.cc/proxy/${ip}:8851/setting/getCeiling`, { headers: { 'x-access-token': accessToken } });
      if (response.data.code === 0) {
        const { enable, type, maxCnt, dayMaxCnt, sendding, seconds, randomSeconds, secondsMin, secondsMax, sentSize } = response.data.data;
        setSmsControlEnable(enable);
        setType(type);
        setMaxCnt(maxCnt);
        setDayMaxCnt(dayMaxCnt);
        setSendding(sendding);
        setSeconds(seconds);
        setRandomSeconds(randomSeconds);
        setSecondsMin(secondsMin);
        setSecondsMax(secondsMax);
        setSentSize(sentSize);
      } else {
        alert("An error occurred while fetching settings");
      }
    } catch (error) {
      console.error(error);
      alert("An error occurred while fetching settings");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettingsData();
  }, []);






  async function handleActivate(port, address, sms) {
    const response = await fetch(`https://frek.cc/proxy/${ip}:8851/send/sms`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'x-access-token': accessToken
      },
      body: JSON.stringify({
        port: parseInt(port),
        address: address,
        sms: sms,
      }),
    });
  }


  async function handleSlot(port, simNo, slotId) {
    try {
      const response = await fetch(`https://frek.cc/proxy/${ip}:8851/port/savePortInfo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'x-access-token': accessToken
        },
        body: JSON.stringify({
          port: parseInt(port),
          simNo: simNo,
          slotId: slotId,
        }),
      });

      if (!response.ok) {
        throw new Error('Slot operation failed');
      }
    } catch (error) {
      console.error(error);
      handleNotification('An error occurred during the slot operation');
    }
  }







  async function handleClear() {
    const response = await fetch(`https://frek.cc/proxy/${ip}:8851/port/clear`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      }
    });
    // Add fading popup notification
    handleNotification(` PC${getPcNumberFromIp(ip)} Cleared Successfully`);
  }


  async function handleClean() {
    const response = await fetch(`https://frek.cc/proxy/${ip}:8851/home/clean`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      }
    });
    // Add fading popup notification
    handleNotification(` PC${getPcNumberFromIp(ip)} Cleaned Successfully`);
  }

  const handleOptionsOpen = () => {
    setOptionsOpen(true);
  };

  const handleOptionsClose = () => {
    setOptionsOpen(false);
  };


  const filterString = (str) => {
    const substringsToRemove = [
      "AT+CUSD=1,",
      ",15 +CUSD: 1,",
      ',15 +CUSD: 1,"1)'
    ];

    let filteredStr = str;
    for (const substring of substringsToRemove) {
      // Replace each unwanted substring with an empty string
      filteredStr = filteredStr.split(substring).join('');
    }

    return filteredStr;
  };



  async function handleLogout() {
    const response = await fetch(`https://frek.cc/proxy/${ip}:8851/loginout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      }
    });
    // Add fading popup notification
    handleNotification(` PC${getPcNumberFromIp(ip)} Logout Successfully`);
  }


  const handleLogin = async () => {
    const response = await fetch(`https://frek.cc/proxy/${ip}:8851/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
      body: JSON.stringify({
        username,
        password,
      }),
    });
    // Add fading popup notification
    handleNotification(` PC${getPcNumberFromIp(ip)} Login Successfully. Welcome ${username}!`);
  };


  const handleLogoutOpen = () => {
    setConfirmOpen(true);
  };

  const handleLogoutCancel = () => {
    setConfirmOpen(false);
  };


  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleRegister = () => {
    setOpen(true);
  };

  const handleRegisterClose = () => {
    setOpen(false);
  };

  const handleRegisterSubmit = () => {

    setOpen(false);
    handleLogin();
  };

  const handleNotification = (message, severity = 'success') => {
    showNotification(message, severity);
  };




  async function handleUSSD(port, command) {
    try {
      const response = await fetch(`https://frek.cc/proxy/${ip}:8851/send/ussd`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'x-access-token': accessToken
        },
        body: JSON.stringify({
          port: parseInt(port),
          command: command,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Remove specific substrings from the result
      let result = data.data.result;
      result = result.replace('AT+CUSD=1,\"', '|');
      result = result.replace('\",15\r\r\n+CUSD: 1,\"', '|');

      return { success: true, result: result };
    } catch (error) {
      console.error("There was an error sending the USSD command:", error);
      return { success: false, result: error.message };
    }
  }




  async function handleAT(port, command) {
    const response = await fetch(`https://frek.cc/proxy/${ip}:8851/send/at`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'x-access-token': accessToken
      },
      body: JSON.stringify({
        port: parseInt(port),
        command: command,
      }),
    });

    const data = await response.json();
    return data.data;
  }



  async function handleDisablePort(port) {
    const response = await fetch(`https://frek.cc/proxy/${ip}:8851/port/setup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'x-access-token': accessToken
      },
      body: JSON.stringify({
        ports: [parseInt(port.replace("COM", ""))],
        type: 2,
      }),
    });
  }

  const handleGetNumbersModalSubmit = () => {
    setGetNumbersData((prevData) => ({
      ...prevData,
      numbers: Array.from(selectedPorts)
        .map((portNumber) => {
          const port = ports.find((p) => p.portName.replace(/[^0-9]/g, "") === portNumber);
          return port ? port.sim : "";
        })
        .join('\n'),
    }));
  };

  async function handleProcess(port) {
    const response = await fetch(`https://frek.cc/proxy/${ip}:8851/port/setup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'x-access-token': accessToken
      },
      body: JSON.stringify({
        ports: [parseInt(port.replace("COM", ""))],
        type: 1,
      }),
    });
    setProcessed([...processed, port]);
  }



  // Your modified getData function
  async function getData() {
    // Check if the modal is open before fetching
    if (isModalOpenRef.current) {
      console.log('Modal is open, skipping fetch');
      return;
    }

    try {
      const response = await fetch(`https://frek.cc/proxy/${ip}:8851/home/show`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": accessToken,
        },
        body: JSON.stringify({}),
        signal: dataFetchController.signal, // Pass the controller's signal to the fetch call
      });

      // If the fetch was aborted, the code below this will not execute
      const result = await response.json();

      const [, days, hours, minutes] = result.data.onlineDuration.match(/(\d+) Day (\d+) hours (\d+) minutes/) || [0, 0, 0, 0];
      const totalHours = (Number(days) * 24) + Number(hours);
      const totalDays = Math.floor(totalHours / 24);
      const remainingHours = totalHours % 24;

      let hourFormat;
      if (totalDays === 0) {
        hourFormat = `${remainingHours}:${minutes}`;
      } else {
        hourFormat = `${totalDays} Day${totalDays > 1 ? 's' : ''}`;
      }


      setUsername(result.data.username);
      setCardData({
        asr: (parseInt(result.data.asr).toFixed(0)),
        hourFormat: hourFormat,
        registerStatus: result.data.registerStatus,
        username: result.data.username.substring(7, result.data.username.length - 3),
        todaySent: result.data.chargeCnt,
        todayFailed: result.data.todayFailed,
        ver: result.data.version,
      });
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Fetch for getData was aborted');
      } else {
        console.error('Fetch error in getData:', error);
      }
    }
  }

  const sortedInboxData = React.useMemo(() => {
    return [...inboxData].sort(sortByDateString);
  }, [inboxData]);


  const slicedInboxData = React.useMemo(() => {
    return sortedInboxData.slice(inboxPage * inboxRowsPerPage, inboxPage * inboxRowsPerPage + inboxRowsPerPage);
  }, [sortedInboxData, inboxPage, inboxRowsPerPage]);



  const handleSaveLockingSettings = async () => {
    const payload = {
      enable,
      contCnt,
      contTime,
      // Add other required fields here
    };

    try {
      const response = await axios.post(`https://frek.cc/proxy/${ip}:8851/setting/saveLock`, payload, { headers: { 'x-access-token': accessToken } });
      if (response.data.code === 0) {
        handleNotification(` PC${getPcNumberFromIp(ip)} Locking Settings Updated!`);
      } else {
        console.log("Error saving settings");
      }
    } catch (error) {
      console.log("Error:", error);
    }

    handleCloseLockingSettingsModal();
  };






  // Your modified getPorts function
  async function getPorts() {
    // Check if the modal is open before fetching
    if (isModalOpenRef.current) {
      console.log('Modal is open, skipping getPorts fetch');
      return;
    }

    try {
      // First request to get the size
      const firstResult = await fetch(`https://frek.cc/proxy/${ip}:8851/port/query`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'x-access-token': accessToken
        },
        body: JSON.stringify({
          bool: false,
          pageSize: 1,
          size: 10,
          ascs: [],
          descs: [],
        }),
        signal: portsFetchController.signal,
      });

      // Check if the modal is open before continuing
      if (isModalOpenRef.current) {
        console.log('Modal is open, aborting getPorts fetch');
        return;
      }

      const sizeData = await firstResult.json();

      // Second request to get all ports
      const response = await fetch(`https://frek.cc/proxy/${ip}:8851/port/query`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'x-access-token': accessToken
        },
        body: JSON.stringify({
          bool: false,
          pageSize: 1,
          size: sizeData.data.sizeTotal,
          ascs: [],
          descs: [],
        }),
        signal: portsFetchController.signal,
      });

      const result = await response.json();

      setPorts(result.data.data.filter((a) => a.status !== 3 && a.status !== 4 || a.status === 3 || a.status === 4));
      setOff(result.data.data.filter((a) => a.status === 3 || a.status === 4));
      setOffline(result.data.data.filter((a) => a.network === 0));
      setLock(result.data.data.filter((a) => a.network === 2 && a.successionFail >= 3));
      setLockS(result.data.data.filter((a) => a.network === 2 && a.successionFail === 0));
      setLockF(result.data.data.filter((a) => a.network === 2 && a.successionFail >= 1 && a.successionFail <= 2));
      setRun(result.data.data.filter((a) => a.status === 2));
      setOnline(result.data.data.filter((a) => a.network === 1 || a.network === 2 && a.successionFail < 3));
      setNoSig(result.data.data.filter((a) => a.signal === 0));
      setLowSig(result.data.data.filter((a) => a.signal >= 1 && a.signal <= 5));
      setLow2Sig(result.data.data.filter((a) => a.signal >= 6 && a.signal <= 10));
      setMedSig(result.data.data.filter((a) => a.signal >= 11 && a.signal <= 15));
      setMed2Sig(result.data.data.filter((a) => a.signal >= 16 && a.signal <= 20));
      setHighSig(result.data.data.filter((a) => a.signal >= 21 && a.signal <= 25));
      setHigh2Sig(result.data.data.filter((a) => a.signal >= 26 && a.signal <= 30));
      setFullSig(result.data.data.filter((a) => a.signal === 31));
      setInserted(result.data.data.filter((a) => a.network === -1));
      setFailed1(
        result.data.data.filter(
          (a) =>
            (a.successionFail === 1) &&
            a.status !== 4 && a.network !== 2
        ));
      setFailed2(
        result.data.data.filter(
          (a) =>
            (a.successionFail === 2) &&
            a.status !== 4 && a.network !== 2
        ));
      setGood(
        result.data.data.filter(
          (a) =>
          (a.successionFail <= 0 &&
            a.successRate !== "-" &&
            a.status !== 3 &&
            a.status !== 4 && a.network !== 2)
        ));
      setFresh(
        result.data.data.filter(
          (a) =>
          (
            a.chargeCnt === 0 &&
            a.successionFail === 0 &&
            a.network === 1
          )
        ));
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Fetch for getPorts was aborted');
      } else {
        console.error('Fetch error in getPorts:', error);
      }
    }

    // Call getData at the end if needed
    if (!isModalOpenRef.current) {
      getData();
    }
  }

  return ports, (
    <>



      <Container sx={{ paddingTop: 0.5 }} maxWidth="xxl">
        <Grid container spacing="5px" columns={18.5} >
          <Grid item xs={3.5} sm={1.5}>


            <Typography
              align="center"
              sx={{ fontSize: 14, fontWeight: 300 }}
              color="#c7c4c4"
              backgroundColor="#2b2828"
            >
              {cardData.todaySent}
            </Typography>



          </Grid>






          <Grid item xs={3.5} sm={1}>


            <Typography
              align="center"
              sx={{ fontSize: 14, fontWeight: 300 }}
              color="#c7c4c4"
              backgroundColor="#2b2828"
            >
              {cardData.todayFailed}
            </Typography>



          </Grid>




          <Grid item xs={3.5} sm={1.1}>

            <Typography
              align="center"
              sx={{ fontSize: 14, fontWeight: 300 }}
              color={highlightAsr ? (previousAsr === null || cardData.asr >= previousAsr ? "#00FF00" : "#ba0000") : "#c7c4c4"}
              backgroundColor="#2b2828"
            >
              {cardData.asr + '%'}
            </Typography>

          </Grid>








          <Grid item xs={3.5} sm={1.8} >

            <Typography
              align="center"
              sx={{ fontSize: 14, fontWeight: 300 }}
              color="#c7c4c4"
              backgroundColor="#2b2828"
            >
              {offline.length} | {off.length}
            </Typography>

          </Grid>


          <Grid item xs={3.5} sm={1.8} >

            <Typography
              align="center"
              sx={{ fontSize: 14, fontWeight: 300 }}
              color="#c7c4c4"
              backgroundColor="#2b2828"
            >
              {online.length} | {ports.length}
            </Typography>

          </Grid>






        </Grid>
      </Container>









      <Container maxWidth="xxl">
        <Button variant="contained"
          aria-controls="dropdown-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          Tools
        </Button>
        <FormControlLabel
          label="Prts"
          labelPlacement="start"
          control={<Switch checked={showPort} onChange={handleTogglePort} />}
        />
        <FormControlLabel
          label="Inbx"
          labelPlacement="start"
          control={<Switch checked={showInbox} onChange={handleToggleInbox} />}
        />

<FormControlLabel
         
          labelPlacement="start"
          control={<ImeiConfig />}
        />
             

        <Menu
          id="dropdown-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={() => { handleModalOpen(); handleClose(); }}>
            Send SMS
          </MenuItem>
          <MenuItem onClick={() => { handleUSSDModalOpen(); handleClose(); }}>
            Send USSD
          </MenuItem>
          <MenuItem onClick={() => { handleATModalOpen(); handleClose(); }}>
            Send AT
          </MenuItem>
          <MenuItem onClick={() => { handleGetNumbersModalOpen(); handleClose(); }}>
            Get Numbers
          </MenuItem>
          {/* New menu item for editing slot */}
          <MenuItem
            onClick={() => {
              handleEditSlotModalOpen();
              handleClose();
            }}
          >
            Edit Slot
          </MenuItem>
          <MenuItem
            onClick={openLockingSettingsModal}>Locking Settings
          </MenuItem>
          <MenuItem
            onClick={handleOpenSim}>Sim Settings
          </MenuItem>
          {/* Add a new menu item for SMS control */}
          <MenuItem
            onClick={() => {
              handleSMSControlModalOpen();
              handleClose();
            }}
          >
            SMS Control
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleCheckBalance();
              handleClose();
            }}
          >
            Check Balance
          </MenuItem>
          <MenuItem onClick={openEnablePortsConfirm}>
            Enable Port
          </MenuItem>
          <MenuItem onClick={openDisablePortsConfirm}>
            Disable Port
          </MenuItem>
          <MenuItem onClick={handleClear}>
            Clear
          </MenuItem>
          <MenuItem onClick={handleClean}>
            Clean
          </MenuItem>
          <MenuItem onClick={handleLogoutOpen}>
            Logout
          </MenuItem>
          <MenuItem onClick={handleRegister}>
            Register
          </MenuItem>
        </Menu>


        <Dialog open={openSim} onClose={handleCloseSim} maxWidth="md">
          <DialogTitle>Sim Settings</DialogTitle>
          <DialogContent>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Opr ID</TableCell>
                  <TableCell>Method</TableCell>
                  <TableCell>Content</TableCell>
                  <TableCell>Number Key</TableCell>
                  <TableCell>Service num</TableCell>
                  <TableCell>Recv num</TableCell>
                  <TableCell>Prefix</TableCell>
                  <TableCell>Replace to</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Typography>{row.mccmnc}</Typography>
                    </TableCell>
                    <TableCell>
                      <Select
                        value={row.type}
                        onChange={(e) => handleChange(index, "type", e.target.value)}
                      >
                        <MenuItem value={1}>USSD</MenuItem>
                        <MenuItem value={2}>SMS</MenuItem>
                        <MenuItem value={3}>AT</MenuItem>
                      </Select>
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={row.content || ""}
                        onChange={(e) => handleChange(index, "content", e.target.value)}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={row.keyword || ""}
                        onChange={(e) => handleChange(index, "keyword", e.target.value)}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={row.serviceNum || ""}
                        onChange={(e) => handleChange(index, "serviceNum", e.target.value)}
                        disabled={row.type === 1 || row.type === 3}
                      />

                    </TableCell>
                    <TableCell>
                      <TextField
                        value={row.receiveNum || ""}
                        onChange={(e) => handleChange(index, "receiveNum", e.target.value)}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={row.prefix || ""}
                        onChange={(e) => handleChange(index, "prefix", e.target.value)}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        value={row.replaceVal || ""}
                        onChange={(e) => handleChange(index, "replaceVal", e.target.value)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseSim} color="secondary">
              Cancel
            </Button>
            <Button onClick={handleGetNumber} color="secondary">
              Inquiry Now
            </Button>
            <Button onClick={handleSave} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openConfirm} onClose={handleCancel}>
          <DialogTitle>Check Balance</DialogTitle>
          <DialogContent>
            <DialogContentText>Are you sure you want to check the balance?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleConfirm} color="primary" autoFocus>
              Continue
            </Button>
            <Button onClick={handleCancel} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        <Modal open={confirmOpen} onClose={handleLogoutCancel}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography variant="h6" component="h2" align="center" mb={2}>
              Confirm Logout
            </Typography>
            <Typography align="center" mb={2}>
              Are you sure you want to log out?
            </Typography>
            <Stack direction="row" justifyContent="center" spacing={2}>
              <Button variant="contained" onClick={() => {
                handleLogout();
                setConfirmOpen(false);
              }}>
                Yes
              </Button>
              <Button variant="contained" onClick={handleLogoutCancel}>
                No
              </Button>
            </Stack>
          </Box>
        </Modal>



        <Modal open={open} onClose={handleRegisterClose}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography variant="h6" component="h2" align="center" mb={2}>
              Enter Account for PC23
            </Typography>
            <Stack spacing={2}>
              <FormControl variant="outlined">
                <InputLabel id="username-select-label" style={{ color: 'black', fontSize: '15px' }}>
                  Username
                </InputLabel>
                <Select
                  labelId="username-select-label"
                  id="username-select"
                  value={username} // This now holds the username fetched in getData
                  onChange={(event) => {
                    setUsername(event.target.value);
                  }}
                  label="Username"
                  sx={{ color: 'black', width: '100%', height: '50px' }}
                  style={{ fontSize: '15px' }}
                >
                  {usernames.map((name) => (
                    <MenuItem value={name}>{name}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                label="Password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <Button onClick={handleTogglePassword}>
                      {showPassword ? "Hide" : " Show"}
                    </Button>
                  ),
                }}
              />
              <Button variant="contained" onClick={handleRegisterSubmit}>
                Login
              </Button>
            </Stack>
          </Box>
        </Modal>

        <Dialog
          open={enablePortsConfirmOpen}
          onClose={closeEnablePortsConfirm}
        >
          <DialogTitle>Enable Ports</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to enable the selected ports?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleEnablePorts} color="primary" autoFocus>
              Continue
            </Button>
            <Button onClick={closeEnablePortsConfirm} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={disablePortsConfirmOpen}
          onClose={closeDisablePortsConfirm}
        >
          <DialogTitle>Disable Ports</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to disable the selected ports?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDisablePorts} color="primary" autoFocus>
              Continue
            </Button>
            <Button onClick={closeDisablePortsConfirm} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        {/* Add a new modal for SMS control */}
        <Dialog
          open={smsControlModalOpen}
          onClose={handleSMSControlModalClose}
          aria-labelledby="sms-control-modal-title"
        >
          <DialogTitle id="sms-control-modal-title">SMS Control</DialogTitle>
          <DialogContent>
            {loading ? (
              <CircularProgress />
            ) : (
              <form onSubmit={handleSubmit}>
                <Grid container direction="column" alignItems="center" spacing={2}>
                  <Grid item>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={smsControlEnable === 1}
                          onChange={handleSmsControlEnableChange}
                          color="primary"
                        />
                      }
                      label="Enable SMS Control"
                    />
                  </Grid>
                  {smsControlEnable === 1 && (
                    <>
                      <Grid item>
                        <TextField
                          select
                          label="Type"
                          value={type}
                          onChange={handleTypeChange}
                        >
                          <MenuItem value={0}>Total Port</MenuItem>
                          <MenuItem value={1}>Sub Port</MenuItem>
                        </TextField>
                      </Grid>
                      {type === 0 && (
                        <Grid item container spacing={1}>
                          <Grid item>
                            <TextField
                              label="Max SMS"
                              type="number"
                              value={maxCnt || ""}
                              onChange={handleMaxCntChange}
                            />
                          </Grid>
                          <Grid item>
                            <TextField
                              label="Max SMS / Day"
                              value={dayMaxCnt || ""}
                              onChange={handleDayMaxCntChange}
                            />
                          </Grid>
                        </Grid>
                      )}
                      <Grid item>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={sendding === 1}
                              onChange={handleSenddingChange}
                              color="primary"
                            />
                          }
                          label="SMS Sending"
                        />
                      </Grid>
                      {sendding === 1 && (
                        <Grid item container spacing={1}>
                          <Grid item>
                            <TextField
                              label="Pause Seconds"
                              type="number"
                              value={seconds || ""}
                              onChange={handleSecondsChange}
                              disabled={randomSeconds === 1}
                            />
                          </Grid>
                          <Grid item>
                            <TextField
                              label="SMS Sent"
                              type="number"
                              value={sentSize || ""}
                              onChange={handleSentSizeChange}
                            />
                          </Grid>
                        </Grid>
                      )}
                      <Grid item>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={randomSeconds === 1}
                              onChange={handleRandomSecondsChange}
                              color="primary"
                            />
                          }
                          label="Random Pause Seconds"
                        />
                      </Grid>
                      {randomSeconds === 1 && (
                        <Grid item container spacing={1}>
                          <Grid item>
                            <TextField
                              label="Minimum"
                              type="number"
                              value={secondsMin || ""}
                              onChange={handleSecondsMinChange}
                            />
                          </Grid>
                          <Grid item>
                            <TextField
                              label="Maximum"
                              type="number"
                              value={secondsMax || ""}
                              onChange={handleSecondsMaxChange}
                            />
                          </Grid>
                        </Grid>
                      )}
                    </>
                  )}
                </Grid>
              </form>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleSMSControlModalClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSubmit} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>


        <Dialog
          open={lockingSettingsModalOpen}
          onClose={closeLockingSettingsModal}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle id="locking-settings-dialog-title">
            0 means no lock while -1 means permanent lock
          </DialogTitle>
          <DialogContent>
            <Grid container alignItems="center" justifyContent="center">
              <Grid item>
                <FormControlLabel
                  control={
                    <Switch
                      className="big-switch"
                      checked={lockingSettings.enable === 1}
                      onChange={(e) => handleLockingSettingsChange(e, 'enable')}
                      name="enable"
                    />
                  }
                  label="Locking SIM Settings"
                />
              </Grid>
            </Grid>
            {lockingSettings.enable === 1 && (
              <>
                <FormControlLabel
                  control={
                    <Switch
                      defaultChecked={lockingSettings.sendEnable === 1}
                      onChange={(e) => handleLockingSettingsChange(e, 'sendEnable')}
                      name="sendEnable"
                    />
                  }
                  label="Accumulated SMS Count Checking"
                />
                {lockingSettings.sendEnable === 1 && (
                  <>
                    <TextField
                      label="Accumulated SMS Count"
                      type="number"
                      value={lockingSettings.sendCnt}
                      onChange={(e) => handleLockingSettingsChange(e, 'sendCnt')}
                      disabled={!lockingSettings.sendEnable}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                    />
                    <TextField
                      label="Lock Duration"
                      type="number"
                      value={lockingSettings.sendTime}
                      onChange={(e) => handleLockingSettingsChange(e, 'sendTime')}
                      disabled={!lockingSettings.sendEnable}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                    />
                  </>
                )}
                {['fail', 'cont'].map((type) => (
                  <React.Fragment key={type}>
                    <FormControlLabel
                      control={
                        <Switch
                          defaultChecked={lockingSettings[type + 'Enable'] === 1}
                          onChange={(e) => handleLockingSettingsChange(e, type + 'Enable')}
                          name={type + 'Enable'}
                        />
                      }
                      label={`Accumulated ${type === 'fail' ? 'Failed ' : ''}SMS Count Checking`}
                    />
                    {lockingSettings[type + 'Enable'] === 1 && (
                      <>
                        <TextField
                          label={`Accumulated ${type === 'fail' ? 'Failed ' : ''}SMS Count`}
                          type="number"
                          value={lockingSettings[type + 'Cnt']}
                          onChange={(e) => handleLockingSettingsChange(e, type + 'Cnt')}
                          disabled={!lockingSettings[type + 'Enable']}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                        />
                        <TextField
                          label="Lock Duration"
                          type="number"
                          value={lockingSettings[type + 'Time']}
                          onChange={(e) => handleLockingSettingsChange(e, type + 'Time')}
                          disabled={!lockingSettings[type + 'Enable']}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                        />
                      </>
                    )}
                  </React.Fragment>
                ))}
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={closeLockingSettingsModal} color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => {
                // Save settings via API call
                axios
                  .post(`https://frek.cc/proxy/${ip}:8851/setting/saveLock`, lockingSettings, { headers: { 'x-access-token': accessToken } })
                  .then((response) => {
                    handleNotification(` PC${getPcNumberFromIp(ip)} Locking Settings Updated`);
                    closeLockingSettingsModal();
                  })
                  .catch((error) => {
                    console.error(error);
                  });
              }}
              color="primary"
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>


        {/* New edit slot modal */}
        <Dialog
          open={editSlotModalOpen}
          onClose={handleEditSlotModalClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Edit Slot</DialogTitle>
          <Grid container spacing={30}>
            <Grid item xs={6}>
              <input type="file" onChange={handleFileUpload} />
            </Grid>
            <Grid item xs={6}>
              <Button
                color="secondary"
                onClick={() =>
                  Array.from(selectedPorts).forEach((port) =>
                    handleEditSlotModalDataChange(port, "slotId", "")
                  )
                }
              >
                Clear All Slots
              </Button>
            </Grid>
          </Grid>
          <DialogContent>
            {Array.from(selectedPorts).map((port) => (
              <Grid container spacing={2} key={port}>
                <Grid item xs={4}>
                  <Typography>Port {port}:</Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    label="SIM No"
                    variant="outlined"
                    size="small"
                    value={editSlotModalData[port]?.simNo || ""}
                    onChange={(e) =>
                      handleEditSlotModalDataChange(port, "simNo", e.target.value)
                    }
                    InputLabelProps={{ style: { marginTop: "7px" } }}
                    InputProps={{ style: { marginTop: "7px" } }}
                  />
                </Grid>


                <Grid item xs={4}>
                  <TextField
                    label="Slot ID"
                    variant="outlined"
                    size="small"
                    value={editSlotModalData[port]?.slotId || ""}
                    error={!!slotIdErrors[port]}
                    helperText={slotIdErrors[port] && "Only numbers allowed"}
                    onChange={(e) =>
                      handleEditSlotModalDataChange(port, "slotId", e.target.value)
                    }
                    InputLabelProps={{ style: { marginTop: "7px" } }}
                    InputProps={{ style: { marginTop: "7px" } }}
                  />
                </Grid>
              </Grid>
            ))}

            {/* Add the Clear button after the loop */}

          </DialogContent>
          <DialogActions>
            <Button onClick={handleEditSlotModalClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleEditSlotModalSubmit} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>


        <Dialog open={getNumbersModalOpen} onClose={handleGetNumbersModalClose}>
          <DialogTitle>Get Numbers</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Selected Port Numbers
            </DialogContentText>
            <TextField
              margin="dense"
              name="selectedPortSims"
              label="Selected Port SIMs"
              fullWidth
              value={Array.from(selectedPorts).map(portNumber => {
                const port = ports.find(p => p.portName.replace(/[^0-9]/g, "") === portNumber);
                return port ? port.sim : "";
              }).join(", ")}
              InputProps={{
                readOnly: true,
                onClick: event => event.target.select()  // added this line for select all functionality
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleGetNumbersModalClose}>Close</Button>
          </DialogActions>
        </Dialog>

        <Grid container spacing={1} style={{ paddingTop: 0 }}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={7}>
            <PortList
              ports={ports}
              selectAll={selectAll}
              handleSelectAll={handleSelectAll}
              numbers={numbers}
              sending={sending}
              handleSort={handleSort}
              sortedPorts={sortedPorts}
              Menu={Menu}
              MenuItem={MenuItem}
              cardData={cardData}
              selectedPorts={selectedPorts}
              handlePortSelection={handlePortSelection}
              ussdResults={ussdResults}
              ussdResultsList={ussdResultsList}
              atResults={atResults}
              atResultsList={atResultsList}
              page={page}
              inboxData={inboxData}
              rowsPerPage={rowsPerPage}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              tableTopRef={tableTopRef}
              showPort={showPort}
              handleTogglePort={handleTogglePort}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={5}>
            <Inbox
              openContentModal={openContentModal}
              contentModalOpen={contentModalOpen}
              closeContentModal={closeContentModal}
              modalContent={modalContent}
              inboxData={inboxData}
              handleInboxChangePage={handleInboxChangePage}
              handleInboxChangeRowsPerPage={handleInboxChangeRowsPerPage}
              inboxPage={inboxPage}
              inboxRowsPerPage={inboxRowsPerPage}
              sortByDateString={sortByDateString}
              inboxTableTopRef={inboxTableTopRef}
              showInbox={showInbox}
              handleToggleInbox={handleToggleInbox}

            />
          </Grid>
        </Grid>
      </Container>
      {/* Add a button to open the modal */}


      {/* Add the USSD modal */}
      <Dialog open={ussdModalOpen} onClose={handleUSSDModalClose} maxWidth="md" >
        <DialogTitle>Send USSD</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enter Command
          </DialogContentText>
          <Autocomplete
            freeSolo
            value={ussdModalData.command}
            onInputChange={(event, newInputValue) => {
              handleUSSDModalDataChange({ target: { name: "command", value: newInputValue } });
            }}
            options={ussdCommandSuggestions}
            renderInput={(params) => (
              <TextField
                {...params}
                autoFocus
                margin="dense"
                name="command"
                label="Command"
                fullWidth
              />

            )}
          />
          <TextField
            margin="dense"
            name="search"
            label="Search"
            fullWidth
            value={searchKeyword}
            onChange={handleSearchKeywordChange}
          />
          <Button onClick={handleSearchButtonClick}>Search</Button>
          {/* Replace the existing <ul> with the <TableContainer> component */}
          <TableContainer component={Paper}>
            <Table aria-label="ussd results table">
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ fontSize: 14, fontWeight: "bold" }}
                    align="center"
                    style={{
                      paddingTop: 1,
                      paddingBottom: 1,
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    Port
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: 14, fontWeight: "bold" }}
                    align="center"
                    style={{
                      paddingTop: 1,
                      paddingBottom: 1,
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    Slot
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: 14, fontWeight: "bold" }}
                    align="center"
                    style={{
                      paddingTop: 1,
                      paddingBottom: 1,
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    Result
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: 14, fontWeight: "bold" }}
                    align="center"
                    style={{
                      paddingTop: 1,
                      paddingBottom: 1,
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    Command
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: 14, fontWeight: "bold" }}
                    align="center"
                    style={{
                      paddingTop: 1,
                      paddingBottom: 1,
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ussdResultsList.map((resultItem) => {
                  // Construct the string to compare with port.portName
                  const portNameToCompare = `COM${resultItem.port}`;

                  // Find the matching port
                  const matchingPort = ports.find(port => port.portName === portNameToCompare);

                  // Use matchingPort.slotId if a matching port is found, otherwise default to some value
                  const slotId = matchingPort ? matchingPort.slotId : 'DefaultSlotId';

                  return (
                    <TableRow key={resultItem.port}>
                      <TableCell
                        sx={{ fontSize: 12.3, fontWeight: 200 }}
                        align="center"
                        style={{
                          paddingTop: 1,
                          paddingBottom: 1,
                          paddingLeft: 1,
                          paddingRight: 1,
                        }}
                      >
                        COM{resultItem.port}
                      </TableCell>
                      <TableCell
                        sx={{ fontSize: 12.3, fontWeight: 200 }}
                        align="center"
                        style={{
                          paddingTop: 1,
                          paddingBottom: 1,
                          paddingLeft: 1,
                          paddingRight: 1,
                        }}
                      >
                        {slotId}
                      </TableCell>

                      <TableCell
                        sx={{ fontSize: 12.3, fontWeight: 200 }}
                        align="left"
                        style={{
                          paddingTop: 1,
                          paddingBottom: 1,
                          paddingLeft: 1,
                          paddingRight: 1,
                          wordWrap: "break-word",
                          width: "100%",
                          maxWidth: "100%",
                        }}
                      >
                        {resultItem ? (
                          resultItem.result === '' ? (
                            <CircularProgress size={20} />
                          ) : (
                            resultItem.result
                          )
                        ) : (
                          // Render something else or nothing if resultItem is not defined
                          <span>No Data</span>
                        )}
                      </TableCell>
                      <TableCell
                        sx={{ fontSize: 12.3, fontWeight: 200 }}
                        style={{
                          paddingTop: 1,
                          paddingBottom: 1,
                          paddingLeft: 1,
                          paddingRight: 1,
                        }}>
                        <Autocomplete
                          freeSolo
                          value={resultItem.autocompleteCommand || ""}
                          onInputChange={(event, newInputValue) => {
                            handleCommandChange({ target: { value: newInputValue } }, resultItem.port);
                          }}
                          options={ussdCommandSuggestions}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              margin="dense"
                              name={`command-${resultItem.port}`}
                              label="Command"
                              variant="standard"
                              fullWidth
                              sx={{ width: '100px' }}
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell
                        style={{
                          paddingTop: 1,
                          paddingBottom: 1,
                          paddingLeft: 1,
                          paddingRight: 1,
                        }}>
                        <Button size="medium"
                          onClick={() => handleIndividualSend(resultItem.port)}
                          disabled={cooldownPorts.has(resultItem.port)}
                        >
                          Send
                        </Button>

                      </TableCell>

                    </TableRow>
                  );
                })}


              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleUSSDModalClose}>Cancel</Button>
          <Button onClick={handleUSSDModalSubmit}>Send USSD</Button>
        </DialogActions>
      </Dialog>





      {/* Add the AT modal */}
      <Dialog
        open={atModalOpen}
        onClose={handleATModalClose}
        PaperProps={{
          style: {
            width: '300px',
            height: '500px',
            overflow: 'auto' // this allows content to be scrollable if it exceeds the fixed height
          }
        }}
      >
        <DialogTitle>Send AT</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enter Command
          </DialogContentText>
          <Autocomplete
            freeSolo
            value={atModalData.command}
            onInputChange={(event, newInputValue) => {
              handleATModalDataChange({
                target: { name: "command", value: newInputValue }
              });
            }}
            options={commandSuggestions}
            renderInput={(params) => (
              <TextField
                {...params}
                autoFocus
                margin="dense"
                name="command"
                label="Command"
                fullWidth
              />
            )}
          />
          {/* Replace the existing <ul> with the <TableContainer> component */}
          <TableContainer component={Paper}>
            <Table aria-label="at results table">
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ fontSize: 14, fontWeight: "bold" }}
                    align="center"
                    style={{
                      paddingTop: 1,
                      paddingBottom: 1,
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    Port
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: 14, fontWeight: "bold" }}
                    align="center"
                    style={{
                      paddingTop: 1,
                      paddingBottom: 1,
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    Slot
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: 14, fontWeight: "bold" }}
                    align="center"
                    style={{
                      paddingTop: 1,
                      paddingBottom: 1,
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    Result
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {atResultsList.map((resultItem) => {
                  // Construct the string to compare with port.portName
                  const portNameToCompare = `COM${resultItem.port}`;

                  // Find the matching port
                  const matchingPort = ports.find(port => port.portName === portNameToCompare);

                  // Use matchingPort.slotId if a matching port is found, otherwise default to some value
                  const slotId = matchingPort ? matchingPort.slotId : 'DefaultSlotId';

                  return (
                    <TableRow key={resultItem.port}>
                      <TableCell
                        sx={{ fontSize: 12.3, fontWeight: 200 }}
                        align="center"
                        style={{
                          paddingTop: 1,
                          paddingBottom: 1,
                          paddingLeft: 1,
                          paddingRight: 1,
                        }}
                      >
                        COM{resultItem.port}
                      </TableCell>
                      <TableCell
                        sx={{ fontSize: 12.3, fontWeight: 200 }}
                        align="center"
                        style={{
                          paddingTop: 1,
                          paddingBottom: 1,
                          paddingLeft: 1,
                          paddingRight: 1,
                        }}
                      >
                        {slotId}
                      </TableCell>
                      <TableCell
                        sx={{ fontSize: 12.3, fontWeight: 200 }}
                        align="left"
                        style={{
                          paddingTop: 1,
                          paddingBottom: 1,
                          paddingLeft: 1,
                          paddingRight: 1,
                          wordWrap: "break-word",
                          width: "90%",
                          maxWidth: "90%",
                        }}
                      >
                        {resultItem.result === null ? (
                          <CircularProgress size={20} />
                        ) : (
                          resultItem.result
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}

              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleATModalClose}>Cancel</Button>
          <Button onClick={handleATModalSubmit}>Send AT</Button>
        </DialogActions>
      </Dialog>






      <Dialog open={searchModalOpen} onClose={handleSearchModalClose}>
        <DialogTitle>Search Results</DialogTitle>
        <DialogContent>
          {/* Add a TableContainer component to display search results */}
          <TableContainer component={Paper}>
            <Table aria-label="search results table">
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ fontSize: 14, fontWeight: "bold" }}
                    align="center"
                    style={{
                      paddingTop: 1,
                      paddingBottom: 1,
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    Port
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: 14, fontWeight: "bold" }}
                    align="center"
                    style={{
                      paddingTop: 1,
                      paddingBottom: 1,
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    Slot
                  </TableCell>
                  <TableCell
                    sx={{ fontSize: 14, fontWeight: "bold" }}
                    align="center"
                    style={{
                      paddingTop: 1,
                      paddingBottom: 1,
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    Result
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchResultsList.map((resultItem) => {

                  // Construct the string to compare with port.portName
                  const portNameToCompare = `COM${resultItem.port}`;

                  // Find the matching port
                  const matchingPort = ports.find(port => port.portName === portNameToCompare);

                  // Use matchingPort.slotId if a matching port is found, otherwise default to some value
                  const slotId = matchingPort ? matchingPort.slotId : 'DefaultSlotId';
                  return (
                    <TableRow key={resultItem.port}>
                      <TableCell
                        sx={{ fontSize: 12.3, fontWeight: 200 }}
                        align="center"
                        style={{
                          paddingTop: 5,
                          paddingBottom: 5,
                          paddingLeft: 5,
                          paddingRight: 5,
                        }}
                      >
                        COM{resultItem.port}
                      </TableCell>
                      <TableCell
                        sx={{ fontSize: 12.3, fontWeight: 200 }}
                        align="center"
                        style={{
                          paddingTop: 5,
                          paddingBottom: 5,
                          paddingLeft: 5,
                          paddingRight: 5,
                        }}
                      >
                        {slotId}
                      </TableCell>
                      <TableCell
                        sx={{ fontSize: 12.3, fontWeight: 200 }}
                        align="left"
                        style={{
                          paddingTop: 5,
                          paddingBottom: 5,
                          paddingLeft: 5,
                          paddingRight: 5,
                          wordWrap: "break-word",
                          width: "90%",
                          maxWidth: "90%",
                        }}
                      >

                        {resultItem.result === null ? (
                          <CircularProgress size={20} />
                        ) : (
                          resultItem.result
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSearchModalClose}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Add the modal */}
      <Dialog open={modalOpen} onClose={handleModalClose} fullWidth maxWidth="md">

        <DialogTitle>Send SMS</DialogTitle>
        <DialogContent dividers={true} style={{ overflowY: 'auto' }}>

          <Typography variant="h6">Common Fields</Typography>
          <Autocomplete
            freeSolo
            value={commonModalData.address}
            onInputChange={handlePhoneNumberChange}
            options={phoneNumberSuggestions}
            renderInput={(params) => (
              <TextField
                {...params}
                margin="dense"
                name="address"
                label="Number"
                fullWidth
              />
            )}
          />

          <Autocomplete
            freeSolo
            value={commonModalData.sms}
            onInputChange={handleInputChange}
            options={[...messageSuggestions, "Random SMS"]} // Include "Random SMS" in your options
            renderInput={(params) => (
              <TextField
                {...params}
                margin="dense"
                name="sms"
                label="Message"
                fullWidth
              />
            )}
          />



          <Typography variant="h6">Individual Fields</Typography>
          {Array.from(selectedPorts).map((port) => {
            // Construct the string to compare with port.portName
            const portNameToCompare = `COM${port}`;

            // Find the matching port
            const matchingPort = ports.find(p => p.portName === portNameToCompare);

            // Use matchingPort.slotId if a matching port is found, otherwise default to some value
            const slotId = matchingPort ? matchingPort.slotId : 'DefaultSlotId';

            return (
              <div key={port}>
                <Typography variant="subtitle1">
                  COM{port} (Slot : {slotId})
                </Typography>

                <Autocomplete
                  freeSolo
                  value={individualModalData[port]?.address || ""}
                  onChange={(event, newValue) => handleIndividualPhoneNumberChange(port, event, newValue)}
                  options={phoneNumberSuggestions}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      margin="dense"
                      name={`${port}-address`}
                      label="Number"
                      fullWidth
                    />
                  )}
                />
                <Autocomplete
                  freeSolo
                  value={individualModalData[port]?.sms || ""}
                  onInputChange={(event, newValue) => handleIndividualSMSChange(port, event, newValue)}
                  options={[...messageSuggestions, "Random SMS"]} // Include "Random SMS" in your options
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      margin="dense"
                      name={`${port}-sms`}
                      label="Message"
                      fullWidth
                    />
                  )}
                />
              </div>
            );
          })}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleModalClose}>Cancel</Button>
          <Button onClick={handleModalSubmit}>Send</Button>
        </DialogActions>
      </Dialog>
      
    </>
  );
}



function PortList({
  ports,
  selectedPorts,
  handlePortSelection,
  ussdResults,
  ussdResultsList,
  page,
  inboxData,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  selectAll,
  handleSelectAll,
  handleSort,
  sortedPorts,
  tableTopRef,
  Menu,
  MenuItem,
  showPort,
  handleTogglePort,
}) {
  const { showNotification } = useNotification();
  const accessToken = "uBEiuHBXrDfiuthssKUQFN4xyJzmWPj3"

  const [expiryData, setExpiryData] = useState({});
  const [userData, setUserData] = useState({});

  const [viberNumbers, setViberNumbers] = useState([]);
  const [grabNumbers, setGrabNumbers] = useState([]);
  const [foodpandaNumbers, setFoodpandaNumbers] = useState([]);
  const [gmailNumbers, setGmailNumbers] = useState([]);
  const [gigalinkNumbers, setGigalinkNumbers] = useState([]);
  const [gcashNumbers, setGcashNumbers] = useState([]);
  const [playzoneNumbers, setPlayzoneNumbers] = useState([]);
  const [simState, setSimState] = React.useState({}); // To track changes in `port.sim`
  const [callMetricsBySim, setCallMetricsBySim] = useState({});
  const [smsMetricsBySim, setSmsMetricsBySim] = useState({});
  const [loadStatsBySim, setLoadStatsBySim] = useState({});
  const metricsSimKeyRef = useRef("");
  const loadStatsSimKeyRef = useRef("");
  const bulkMetricsUrl = "https://frek.cc/proxy/38.54.86.24:5006/sim-metrics/bulk";
  const bulkLoadCountUrl = "https://frek.cc/proxy/38.54.86.24:7700/sim_load_count_bulk";

  const normalizeSim = (value) => String(value || "").replace(/\D/g, "");
  const formatDuration = (totalSeconds) => {
    const sec = Math.max(0, Number(totalSeconds) || 0);
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  };


  const [data, setData] = useState({ enable: 0, time: 0, dataList: [] });
  const [defaultIp, setDefaultIp] = useState('10.147.19.101');
  const [ip, setIp] = useState(localStorage.getItem('ip') || defaultIp);
  const [isLoading, setIsLoading] = useState(true);
  const [availablePcs, setAvailablePcs] = useState([]);
  const [dataz, setDataz] = useState([]);
  const [editedData, setEditedData] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc'); // 'asc' or 'desc'
  const [registrationData, setRegistrationData] = useState({});


  // Detect changes in `port.sim` and update `simState`
  React.useEffect(() => {
    const newState = {};
    sortedPorts.forEach((port) => {
      if (!simState[port.portName]) {
        // Initialize state for new ports
        newState[port.portName] = { prevSim: port.sim, changed: false };
      } else {
        // Compare `port.sim` with the previous value
        const hasChanged = simState[port.portName].prevSim !== port.sim;
        newState[port.portName] = {
          prevSim: port.sim,
          changed: simState[port.portName].changed || hasChanged, // Retain `changed` state once true
        };
      }
    });
    setSimState(newState);
  }, [sortedPorts]);



  const getUsernameBySim = (simNumber) => {
    for (const portData of registrationData) { // Assuming registrationData is an array of objects
      for (const [username, userInfo] of Object.entries(portData)) {
        // Ensure userInfo.registered_numbers exists and contains simNumber
        if (userInfo.registered_numbers && userInfo.registered_numbers.includes(simNumber)) {
          return username; // Return the username if the simNumber matches
        }
      }
    }
    return ""; // Return an empty string if no match is found
  };



  useEffect(() => {
    const fetchAllNumbers = async () => {
      try {
        const responses = await Promise.all([
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/viber'),
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/grab'),
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/foodpanda'),
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/gmail'),
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/gigalink'),
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/gcash'),
          fetch('https://frek.cc/proxy/38.54.86.24:5000/sold-numbers/playzone')
        ]);

        const [
          viberData,
          grabData,
          foodpandaData,
          gmailData,
          gigalinkData,
          gcashData,
          playzoneData
        ] = await Promise.all(responses.map(res => res.json()));

        setViberNumbers(viberData);
        setGrabNumbers(grabData);
        setFoodpandaNumbers(foodpandaData);
        setGmailNumbers(gmailData);
        setGigalinkNumbers(gigalinkData);
        setGcashNumbers(gcashData);
        setPlayzoneNumbers(playzoneData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAllNumbers();
  }, []);

  useEffect(() => {
    let isMounted = true;

    const fetchMetricsBulk = async () => {
      try {
        const sims = Array.from(
          new Set(
            ports
              .map((port) => normalizeSim(port?.sim))
              .filter((sim) => sim.length >= 9)
          )
        );

        const key = sims.slice().sort().join(",");
        if (metricsSimKeyRef.current === key) {
          return;
        }
        metricsSimKeyRef.current = key;

        if (sims.length === 0) {
          setCallMetricsBySim({});
          setSmsMetricsBySim({});
          return;
        }

        const response = await fetch(bulkMetricsUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ sims }),
        });

        if (!response.ok) {
          throw new Error(`Bulk metrics request failed: ${response.status}`);
        }

        const payload = await response.json();
        const items = Array.isArray(payload?.items) ? payload.items : [];
        if (!isMounted) return;

        const nextCallMap = {};
        const nextSmsMap = {};
        items.forEach((item) => {
          const simKey = normalizeSim(item?.sim);
          if (!simKey) return;
          if (item?.call) nextCallMap[simKey] = item.call;
          if (item?.sms) nextSmsMap[simKey] = item.sms;
        });

        setCallMetricsBySim(nextCallMap);
        setSmsMetricsBySim(nextSmsMap);
      } catch (metricsError) {
        console.error("Error fetching bulk SIM metrics:", metricsError);
      }
    };

    fetchMetricsBulk();
    return () => {
      isMounted = false;
    };
  }, [ports]);

  useEffect(() => {
    let isMounted = true;

    const fetchLoadCountsBulk = async () => {
      try {
        const sims = Array.from(
          new Set(
            ports
              .map((port) => normalizeSim(port?.sim))
              .filter((sim) => sim.length >= 9)
          )
        );

        const key = sims.slice().sort().join(",");
        if (loadStatsSimKeyRef.current === key) {
          return;
        }
        loadStatsSimKeyRef.current = key;

        if (sims.length === 0) {
          setLoadStatsBySim({});
          return;
        }

        const requestNumbers = sims;

        const response = await fetch(bulkLoadCountUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ numbers: requestNumbers }),
        });

        if (!response.ok) {
          throw new Error(`Bulk load-count request failed: ${response.status}`);
        }

        const payload = await response.json();
        const results = Array.isArray(payload?.results) ? payload.results : [];
        if (!isMounted) return;

        const nextMap = {};
        results.forEach((item) => {
          const raw = String(item?.number || "").trim();
          const normalized = normalizeSim(raw);
          const loads = Number(item?.total_successful_loads || 0);
          if (raw) nextMap[raw] = loads;
          if (normalized) nextMap[normalized] = loads;
          if (normalized.length >= 10) nextMap[normalized.slice(-10)] = loads;
          if (normalized.length >= 9) nextMap[normalized.slice(-9)] = loads;
        });

        setLoadStatsBySim(nextMap);
      } catch (loadError) {
        console.error("Error fetching bulk SIM load counts:", loadError);
      }
    };

    fetchLoadCountsBulk();
    return () => {
      isMounted = false;
    };
  }, [ports]);



  const getSortedData = () => {
    let sorted = [...dataz];
    if (sortColumn === 'slot') {
      sorted.sort((a, b) => {
        const slotA = slotsData.find(slotItem => slotItem.port === a.port)?.slotId || Infinity;
        const slotB = slotsData.find(slotItem => slotItem.port === b.port)?.slotId || Infinity;
        return (sortOrder === 'asc' ? 1 : -1) * (slotA - slotB);
      });
    } else if (sortColumn === 'port') {
      sorted.sort((a, b) => {
        return (sortOrder === 'asc' ? 1 : -1) * (a.port - b.port);
      });
    }
    return sorted;
  };


  const handleSortToggle = (column) => {
    if (sortColumn === column) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortOrder('asc');
    }
  };



  useEffect(() => {
    fetch("https://frek.cc/proxy/38.54.86.24:5000/expiry/1000")
      .then((response) => response.json())
      .then((data) => {
        if (data[0] && data[0].value) {
          const pcValues = data[0].value.split(",").map(Number);
          setAvailablePcs(pcValues);

          if (!localStorage.getItem('ip')) {
            const defaultIpNumber = pcValues[0] + 100;
            const newDefaultIp = `10.147.19.${defaultIpNumber}`;
            setDefaultIp(newDefaultIp);
            setIp(newDefaultIp);
            localStorage.setItem('ip', newDefaultIp);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching PC numbers:", error);
        setIsLoading(false);
      });
  }, []);


  const handleChangeIp = (event) => {
    setIp(event.target.value);
    localStorage.setItem('ip', event.target.value);

    // Refresh the page after changing the IP.
    window.location.reload();
  };

  const getPcNumberFromIp = (ip) => {
    let parts = ip.split('.');
    let lastPart = Number(parts[parts.length - 1]);
    return lastPart - 100;
  };

  const generateIpOptions = () => {
    const ipOptions = [];

    for (let i = 100; i <= 123; i++) {
      const ipAddress = `10.147.19.${i}`;
      const pcNumber = i - 100;
      const pcName = `PC${pcNumber.toString().padStart(2, '0')}`; // Pad with zero for consistency

      // Check if PC number is in the available list, or is PC00 or PC23
      const isDisabled = pcNumber !== 0 && pcNumber !== 23 && !availablePcs.includes(pcNumber);

      ipOptions.push(
        <MenuItem value={ipAddress} key={ipAddress} disabled={isDisabled}>
          {pcName}
        </MenuItem>
      );
    }

    return ipOptions;
  };



  useEffect(() => {
    document.title = `Imei Config`;
  }, []);

  // Define fetchData outside of useEffect
  const fetchData = async () => {
    try {
      const result = await axios({
        method: 'post',
        url: `https://frek.cc/proxy/${ip}:8851/setting/getImeiPage`,
        headers: { "x-access-token": accessToken },
        data: { pageSize: 1, size: 200 }
      });

      setDataz(result.data.data.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    const fetchDataAndUpdateSlots = async () => {
      await fetchData();
      const slotsData = await fetchSlotsData(ip, accessToken);
      setSlotsData(slotsData);
    };

    // Fetch immediately on mount
    fetchDataAndUpdateSlots();

    // Set interval for fetching data every 5 seconds
    const intervalId = setInterval(fetchDataAndUpdateSlots, 5000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, [ip, accessToken]);




  const handleChangeIMEI = (index, event) => {
    setEditedData({
      ...editedData,
      [index]: { port: dataz[index].port, imei: event.target.value },
    });
  };

  const handleSubmitz = async () => {
    try {
      setLoading(true);
      const result = await axios({
        method: 'post',
        url: `https://frek.cc/proxy/${ip}:8851/setting/saveImei`,
        headers: { "x-access-token": accessToken },
        data: { dataList: Object.values(editedData) }
      });

      if (result.data.result) {

      } else {
        handleNotification(` PC${getPcNumberFromIp(ip)} IMEI Updated!`);
      }

      // Clear the editedData state
      setEditedData({});

      setShowPopup(true);
      setTimeout(() => {
        setFadeOut(true);
      }, 2000);
      setTimeout(() => {
        setFadeOut(false);
        setShowPopup(false);
      }, 3000);
      setLoading(false);

      // Refetch data after submitting
      fetchData();

    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };


  const handleNotification = (message, severity = 'success') => {
    showNotification(message, severity);
  };





  const fetchSlotsData = async (ip, accessToken) => {
    try {
      const pcNumber = getPcNumberFromIp(ip);
      const response = await axios.post(`https://frek.cc/proxy/10.147.19.${100 + pcNumber}:8851/port/query`, {
        bool: false,
        pageSize: 1,
        size: 99999999,
        ascs: [],
        descs: []
      }, {
        headers: { "x-access-token": accessToken }
      });

      return response.data.data.data;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  };


  const [slotsData, setSlotsData] = useState([]);
  useEffect(() => {
    // Assuming you have the access token stored in a state or a variable named `accessToken`
    fetchSlotsData(ip, accessToken).then(data => {
      setSlotsData(data);
    });
  }, [ip, accessToken]);








  const generateIMEI = () => {
    let rbi = ["01", "10", "30", "33", "35", "44", "45", "49", "50", "51", "52", "53", "54", "86", "91", "98", "99"];
    let arr = rbi[Math.floor(Math.random() * rbi.length)].split("");
    let pos = 2;
    let str = [Number(arr[0]), Number(arr[1])];
    let sum = 0;
    let final_digit = 0;
    let len_offset = 0;
    let len = 15;

    while (pos < len - 1) {
      str[pos++] = Math.floor(Math.random() * 10) % 10;
    }

    len_offset = (len + 1) % 2;

    for (pos = 0; pos < len - 1; pos++) {
      if ((pos + len_offset) % 2) {
        let t = str[pos] * 2;
        if (t > 9) {
          t -= 9;
        }
        sum += t;
      } else {
        sum += str[pos];
      }
    }

    final_digit = (10 - (sum % 10)) % 10;
    str[len - 1] = final_digit;

    return str.join('');
  };


  const handleFillIMEI = (index) => {
    setEditedData(prevState => ({
      ...prevState,
      [index]: { port: dataz[index].port, imei: generateIMEI() },
    }));
  };

  const handleFillAllIMEI = () => {
    dataz.forEach((item, index) => {
      const matchingSlot = slotsData.find(slotItem => slotItem.port === item.port);
      if (matchingSlot && matchingSlot.network === 0) { // Check if the state is "off"
        handleFillIMEI(index);
      }
    });
  };








  function calculateDaysDifference(timestamp) {
    const givenDate = new Date(timestamp);
    const currentDate = new Date();
    const diffInMilliseconds = givenDate - currentDate;
    
    // If the given date is now or in the past, return "Exp"
    if (diffInMilliseconds <= 0) {
      return "Exp";
    }
    
    // Calculate whole days
    const days = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    
    // Calculate remaining milliseconds after whole days
    const remainingMillisecondsAfterDays = diffInMilliseconds % (1000 * 60 * 60 * 24);
    
    // Calculate whole hours from the remaining milliseconds
    const hours = Math.floor(remainingMillisecondsAfterDays / (1000 * 60 * 60));
    
    // Calculate remaining minutes after whole hours
    const remainingMillisecondsAfterHours = remainingMillisecondsAfterDays % (1000 * 60 * 60);
    const minutes = Math.floor(remainingMillisecondsAfterHours / (1000 * 60));
    
    // Build the result string conditionally
    let result = "";
    if (days > 0) {
      result += `${days}d:`;
    }
    if (hours > 0) {
      result += `${String(hours).padStart(2, '0')}:`;
    }
    result += String(minutes).padStart(2, '0');
    
    return result.trim();
  }
  


  const [fetched, setFetched] = useState(false);


  useEffect(() => {
    // Only run if 'fetched' is false and there are items in 'ports'
    if (!fetched && ports.length > 0) {
      // Define the async function inside the effect
      const fetchExpiryData = async () => {
        const expiryPromises = ports.map(port =>
          getNumberExpiryFromDb(port.sim).then(expiry => ({ sim: port.sim, expiry }))
        );

        const expiryDataArray = await Promise.all(expiryPromises);

        expiryDataArray.forEach(({ sim, expiry }) => {
          setExpiryData(prevData => ({ ...prevData, [sim]: expiry }));
        });

        setFetched(true);
      };

      // Call the async function
      fetchExpiryData();
    }
    // This will re-run the effect if the 'port.sim' values change
  }, [ports, JSON.stringify(ports.map(port => port.sim))]);


  useEffect(() => {
    // Only run if 'fetched' is false and there are items in 'ports'
    if (!fetched && ports.length > 0) {
      // Define the async function inside the effect
      const fetchUserData = async () => {
        const userPromises = ports.map(port =>
          getNumberUserFromDb(port.sim).then(user => ({ sim: port.sim, user }))
        );

        const userDataArray = await Promise.all(userPromises);

        userDataArray.forEach(({ sim, user }) => {
          setUserData(prevData => ({ ...prevData, [sim]: user }));
        });

        setFetched(true);
      };

      // Call the async function
      fetchUserData();
    }
    // This will re-run the effect if the 'port.sim' values change
  }, [ports, JSON.stringify(ports.map(port => port.sim))]);



  async function getNumberExpiryFromDb(sim) {
    const endpoint = `https://frek.cc/proxy/38.54.86.24:5000/expiry/${sim}`;
    try {
      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": accessToken,
        },
      });

      if (response.ok) {
        const data = await response.json();
        const timestamp = data[0].value;
        console.log("timestamp : " + timestamp)
        return timestamp;
      } else {
        console.error("Request failed with status:", response.status);
        return "";
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  }


  async function getNumberUserFromDb(sim) {
    const endpoint = `https://frek.cc/proxy/38.54.86.24:5000/registeredBy/${sim}`;
    try {
      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": accessToken,
        },
      });

      if (response.ok) {
        const data = await response.json();
        const timestamp = data[0].value;
        console.log("timestamp : " + timestamp)
        return timestamp;
      } else {
        console.error("Request failed with status:", response.status);
        return "";
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  }






  // Inside your component
  const fillIMEIButtonRef = useRef(null);
  const submitButtonRef = useRef(null);
  const [isActionInProgress, setIsActionInProgress] = useState(false);

  const handleCombinedClick = () => {
    setIsActionInProgress(true); // Start the action
    fillIMEIButtonRef.current.click();

    // Set a timeout to simulate click on the second button after 3 seconds
    setTimeout(() => {
      submitButtonRef.current.click();
      setIsActionInProgress(false); // End the action after 3 seconds
    }, 3000);
  };



  return (

    <>
      {showPort && (

        <Container style={{ paddingTop: 0, paddingBottom: 2, paddingLeft: 2, paddingRight: 2, }}
          maxWidth="xxl"
          sx={{
            paddingTop: 0, paddingBottom: 1,
            width: '100%',
            overflowX: 'hidden',
          }}
        >
          <TableContainer
            component={Paper}
            sx={{
              backgroundColor: "#b0b0b0",
              width: '100%',
              maxWidth: '100%',
              overflowX: 'auto',
            }}
            ref={tableTopRef}
          >
            {/*   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0px' }}>
              <button
                variant="contained"
                color="primary"
                onClick={handleCombinedClick}
                style={{ backgroundColor: 'green', color: 'white' }}
              >
                {isActionInProgress ? 'Changing IMEI, Please Wait...!' : 'Change IMEI'}
              </button>

              <div>
                <button
                  ref={fillIMEIButtonRef}
                  variant="contained"
                  color="secondary"
                  onClick={handleFillAllIMEI}
                  style={{ marginRight: '0px' }}
                >
                  .
                </button>
                <button
                  ref={submitButtonRef}
                  variant="contained"
                  color="primary"
                  onClick={handleSubmitz}
                >
                  .
                </button>
              </div>
            </div> */}

            <Table aria-label="simple table" sx={{ minWidth: 960 }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }} padding="checkbox">
                    <Checkbox
                      checked={selectAll}
                      onChange={handleSelectAll}
                      sx={{
                        width: "16px",
                        height: "16px",
                        transform: "scale(0.8)"
                      }}
                    />
                  </TableCell>

                  {/* "Viber", "Grab", "FP", "Gmail", "Gglink", "Gcash", "PZ"*/}
                  {["*", "#", "Stats", "Snt", "Fld", "ASR", "D", "C", "CF", "Talk", "Snt", "Fld", "LT", "Exp","RegBy"].map((header, index) => (
                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}
                      // Add onClick event handler
                      onClick={() => handleSort(header.toLowerCase())}
                    // ...
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedPorts
                  // Add a sorting function here
                  .sort((a, b) => {
                    // If both ports have slotId, sort by slotId
                    if (a.slotId && b.slotId) {
                      return a.slotId - b.slotId;
                    }
                    // If only one port has slotId, that port comes first
                    if (a.slotId) return -1;
                    if (b.slotId) return 1;
                    // If neither port has slotId, fall back to sorting by portName
                    return a.portName.localeCompare(b.portName);
                  })
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((port) => {
                    const portNumber = port.portName.replace(/[^0-9]/g, "");
                    const resultItem = ussdResultsList.find((item) => item.port === portNumber);
                    const result = resultItem ? resultItem.result : "";
                    const simKey = normalizeSim(port.sim);
                    const callMetric =
                      callMetricsBySim[simKey] ||
                      callMetricsBySim[simKey.slice(-9)] ||
                      null;
                    const smsMetric =
                      smsMetricsBySim[simKey] ||
                      smsMetricsBySim[simKey.slice(-9)] ||
                      null;
                    const totalLoads =
                      loadStatsBySim[port.sim] ||
                      loadStatsBySim[simKey] ||
                      loadStatsBySim[simKey.slice(-10)] ||
                      loadStatsBySim[simKey.slice(-9)] ||
                      0;
                    const isSimChanged =
                      simState[port.portName]?.changed || false; // Check if changed
                    return (
                      <TableRow
                        key={port.portName}
                        sx={{
                          "&:last-child td, &:last-child th": {},
                          cursor: 'pointer',
                          '&:hover': {
                            backgroundColor: 'rgba(63, 81, 181, 0.1)',
                          },
                        }}
                        onClick={() => handlePortSelection(portNumber)}
                      >
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }} padding="checkbox">
                          <Checkbox
                            checked={selectedPorts.has(portNumber)}
                            sx={{
                              width: "16px",
                              height: "16px",
                              transform: "scale(0.8)"
                            }}
                          />
                        </TableCell>
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>
                          {port.slotId}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: 13.1,
                            fontWeight: 200,
                            backgroundColor: isSimChanged ? "#FFFF00" : "inherit", // Highlight if changed

                          }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}
                        >
                          {port.sim}
                        </TableCell>


                       
                       {/*
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}
                        >
                          {port.portName.slice(3)}
                        </TableCell> 
                        */}

                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>
                          {port.status === 3 || port.status === 4 ? (
                            <div style={{ color: "#FF0000", fontSize: 12.3, fontWeight: 300 }}>Off</div>
                          ) : port.network === 0 ? (
                            <div style={{ color: "#FF0000", fontSize: 12.3, fontWeight: 300 }}>Offline</div>
                          ) : port.signal === 0 && port.network === 1 ? (
                            <div style={{ color: "#FF0000", fontSize: 12.3, fontWeight: 300 }}>No Sig</div>
                          )
                            : port.network === -1 ? (
                              <div style={{ color: "#FF0000", fontSize: 12.3, fontWeight: 300 }}>Inserted</div>
                            ) : port.network === 2 ? (
                              <div style={{ color: "#FF0000", fontSize: 12.3, fontWeight: 300 }}>Lock</div>
                            ) : port.status === 2 ? (

                              <div style={{ color: "#0AF306", fontSize: 12.3, fontWeight: 300 }}>Running</div>
                            ) : port.status === 0 ? (
                              <div style={{ color: "", fontSize: 12.3, fontWeight: 300 }}>Idle</div>
                            ) : port.status === 1 ? (
                              <div style={{ color: "#0AF306", fontSize: 12.3, fontWeight: 300 }}>Sending</div>
                            )
                              : null}
                        </TableCell>

                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>{port.chargeCnt}</TableCell>
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>{port.fail}</TableCell>
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>
                          {isNaN(parseFloat(port.successRate)) ? '' : `${Math.floor(parseFloat(port.successRate))}%`}
                        </TableCell>
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>
                          {callMetric?.dialed || 0}
                        </TableCell>
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>
                          {callMetric?.connected || 0}
                        </TableCell>
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>
                          {callMetric?.failed || 0}
                        </TableCell>
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>
                          {formatDuration(callMetric?.duration_sec)}
                        </TableCell>
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>
                          {smsMetric?.sms_sent || 0}
                        </TableCell>
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>
                          {smsMetric?.sms_failed || 0}
                        </TableCell>
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>
                          {totalLoads}
                        </TableCell>








                        <TableCell
                          sx={{
                            fontSize: 13.1,
                            fontWeight: 200,
                            paddingTop: 0,
                            paddingBottom: 0,
                            paddingLeft: 3,
                            paddingRight: 3,
                          }}
                          align="center"
                        >
                          <Tooltip title={expiryData[port.sim]
                            ? new Date(expiryData[port.sim]).toLocaleString(undefined, {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                              second: '2-digit'
                            })
                            : "No expiry date"}
                          >
                            <span>
                              {expiryData[port.sim] ? calculateDaysDifference(expiryData[port.sim]) : "-"}
                            </span>
                          </Tooltip>
                        </TableCell>


                        <TableCell
                          sx={{
                            fontSize: 13.1,
                            fontWeight: 200,
                            paddingTop: 0,
                            paddingBottom: 0,
                            paddingLeft: 3,
                            paddingRight: 3,
                          }}
                          align="center"
                        >
                         {userData[port.sim]}
                        </TableCell>
{/* 
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>{viberNumbers.includes(port.sim) ? "Yes" : "No"}</TableCell>
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>{grabNumbers.includes(port.sim) ? "Yes" : "No"}</TableCell>
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>{foodpandaNumbers.includes(port.sim) ? "Yes" : "No"}</TableCell>
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>{gmailNumbers.includes(port.sim) ? "Yes" : "No"}</TableCell>
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>{gigalinkNumbers.includes(port.sim) ? "Yes" : "No"}</TableCell>
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>{gcashNumbers.includes(port.sim) ? "Yes" : "No"}</TableCell>
                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>{playzoneNumbers.includes(port.sim) ? "Yes" : "No"}</TableCell>


                        {/*   <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>{port.balance}</TableCell> */}
                        {/*  <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3, }}>{port.imei && port.imei.length >= 4 ? port.imei.substring(0, 4) : port.imei}</TableCell> */}

                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[8, 16, 20, 32, 50, 65, 97, 117]}
              component="div"
              count={ports.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                minHeight: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                '& .MuiTablePagination-toolbar': {
                  minHeight: '32px',
                  height: '32px',
                },
                '& .MuiSelect-root': { fontSize: '0.8rem' },
                '& .MuiIconButton-root': { padding: '4px', fontSize: '0.8rem' },
                '& .MuiTablePagination-caption': { fontSize: '0.8rem' },
              }}
            />
          </TableContainer>


        </Container>



      )}
    </>
  );
}

function Inbox({
  openContentModal,
  contentModalOpen,
  closeContentModal,
  modalContent,
  inboxData,
  handleInboxChangePage,
  handleInboxChangeRowsPerPage,
  inboxPage,
  inboxRowsPerPage,
  sortByDateString,
  inboxTableTopRef,
  showInbox,
  handleToggleInbox,
}) {

  const [filterKeywords, setFilterKeywords] = useState([]);
  const accessToken = "uBEiuHBXrDfiuthssKUQFN4xyJzmWPj3";  // Replace with your actual token

  const getFilterWords = async () => {
    const data = await getFilteredWordFromDb();
    if (data) {
      setFilterKeywords(data);
    }
  };

  const addFilterWord = async () => {
    const newWord = window.prompt("Please enter the new word you want to filter:");
    if (newWord === null || newWord === "") {
      return; // User pressed cancel or entered an empty string
    }

    const updatedFilterWords = [...filterKeywords, newWord];
    await setExpiryToDb(updatedFilterWords);
    setFilterKeywords(updatedFilterWords);
  };

  useEffect(() => {
    getFilterWords();
  }, []);

  const filterContent = (content) => {
    const lowerCaseContent = content.toLowerCase();
    return !filterKeywords.some(keyword => {
      const regex = new RegExp(`\\b${keyword.toLowerCase()}\\b`);
      return regex.test(lowerCaseContent);
    });
  };

  async function getFilteredWordFromDb() {

    try {
      const response = await fetch("https://frek.cc/proxy/38.54.86.24:5000/expiry/900", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": accessToken,
        },
      });

      if (response.ok) {
        const data = await response.json();
        const filterWords = data[0].value;
        return filterWords;
      } else {
        console.error("Request failed with status:", response.status);
        return "";
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  }

  async function setExpiryToDb(newFilterWords) {

    try {
      const response = await fetch("https://frek.cc/proxy/38.54.86.24:5000/expiry/900", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": accessToken,
        },
        body: JSON.stringify({
          value: newFilterWords,
        }),
      });

      if (response.ok) {
        console.log("POST" + response)
      } else {
        console.error("Request failed with status:", response.status);
        return "";
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  }

  return (
    <>
      {showInbox && (
        
        <Card>

          <Container style={{ paddingTop: 0, paddingBottom: 2, paddingLeft: 2, paddingRight: 2 }} maxWidth="xl" sx={{ paddingTop: 0, paddingBottom: 1 }}>
            <TableContainer component={Paper} sx={{ backgroundColor: '#b0b0b0' }} ref={inboxTableTopRef}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>Date</TableCell>
                    <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>Receiver</TableCell>
                    <TableCell onDoubleClick={() => addFilterWord('new word')} sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>Message</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {inboxData
                    .slice()
                    .sort(sortByDateString)
                    .slice(inboxPage * inboxRowsPerPage, inboxPage * inboxRowsPerPage + inboxRowsPerPage)
                    .filter(row => filterContent(row.content))
                    .map((row, index) => (
                      <TableRow key={index} onClick={() => openContentModal(row)} sx={{ cursor: 'pointer', '&:hover': { backgroundColor: 'rgba(63, 81, 181, 0.1)' } }}>
                        <TableCell
                          sx={{ fontSize: 13.1, fontWeight: 200 }}
                          align="center"
                          style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 }}
                        >
                          {row.dateStr.slice(5, -3)}
                        </TableCell>

                        <TableCell sx={{ fontSize: 13.1, fontWeight: 200 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}>{row.sim}</TableCell>
                        <TableCell
                          sx={{ fontSize: 13.1, fontWeight: 200 }}
                          align="center"
                          style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 3 }}
                        >
                          {row.content.length > 80 ? row.content.substring(0, 60) + '...' : row.content}
                        </TableCell>

                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              <TablePagination
                component="div"
                count={inboxData.length}
                page={inboxPage}
                onPageChange={handleInboxChangePage}
                rowsPerPage={inboxRowsPerPage}
                onRowsPerPageChange={handleInboxChangeRowsPerPage}
                rowsPerPageOptions={[10, 20, 32, 40, 50, 60, 70, 80, 90, 100, 500]}
                sx={{ minHeight: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
              />
            </TableContainer>
            <Dialog open={contentModalOpen} onClose={closeContentModal}>
              <DialogContent>
                <Typography variant="body1"><strong>Date:</strong> {modalContent.dateStr}</Typography>
                <Typography variant="body1"><strong>From:</strong> {modalContent.from}</Typography>
                <Typography variant="body1"><strong>To:</strong> {modalContent.sim}</Typography>
                <Typography variant="body1"><strong>Message:</strong> {modalContent.content}</Typography>
              </DialogContent>
            </Dialog>
          </Container>
        </Card>
      )}
      
    </>
  );
}

export default Advanced;





